// This file is auto-generated by @hey-api/openapi-ts

import {
  client,
  type Options,
  formDataBodySerializer,
} from '@hey-api/client-fetch';
import type {
  ListActivitiesofaProjectObjectData,
  ListActivitiesofaProjectObjectError,
  ListActivitiesofaProjectObjectResponse,
  PostCreateanewexportRequestData,
  PostCreateanewexportRequestError,
  PostCreateanewexportRequestResponse,
  GetExportdetailsData,
  GetExportdetailsError,
  GetExportdetailsResponse,
  PostActivitiesListData,
  PostActivitiesListError,
  PostActivitiesListResponse,
  ActivityDetailsbyactivityIdData,
  ActivityDetailsbyactivityIdError,
  ActivityDetailsbyactivityIdResponse,
  ActivitylogsbyactivityIdData,
  ActivitylogsbyactivityIdError,
  ActivitylogsbyactivityIdResponse,
  ListallClashesinaprojectData,
  ListallClashesinaprojectError,
  ListallClashesinaprojectResponse,
  CreateaNewClashData,
  CreateaNewClashError,
  CreateaNewClashResponse,
  GetClashDetailsData,
  GetClashDetailsError,
  GetClashDetailsResponse,
  DeleteClashData,
  DeleteClashError,
  DeleteClashResponse,
  UpdateClashData,
  UpdateClashError,
  UpdateClashResponse,
  ListAllClashItemsData,
  ListAllClashItemsError,
  ListAllClashItemsResponse2,
  ListallCommentsData,
  ListallCommentsError,
  ListallCommentsResponse,
  CreateaNewCommentData,
  CreateaNewCommentError,
  CreateaNewCommentResponse,
  GetCommentDetailsData,
  GetCommentDetailsError,
  GetCommentDetailsResponse,
  DeleteCommentData,
  DeleteCommentError,
  DeleteCommentResponse,
  UpdateCommentData,
  UpdateCommentError,
  UpdateCommentResponse,
  GetListallattachmentsData,
  GetListallattachmentsError,
  GetListallattachmentsResponse,
  PostAddattachmentsData,
  PostAddattachmentsError,
  PostAddattachmentsResponse,
  DeleteRemoveattachmentsData,
  DeleteRemoveattachmentsError,
  DeleteRemoveattachmentsResponse,
  ListReactionsToCommentData,
  ListReactionsToCommentError,
  ListReactionsToCommentResponse,
  AddReactionToCommentData,
  AddReactionToCommentError,
  AddReactionToCommentResponse2,
  DeleteReactionToCommentData,
  DeleteReactionToCommentError,
  DeleteReactionToCommentResponse,
  ListCompaniesError,
  ListCompaniesResponse,
  GetCompanyDetailsData,
  GetCompanyDetailsError,
  GetCompanyDetailsResponse,
  UpdateCompanyData,
  UpdateCompanyError,
  UpdateCompanyResponse,
  RemoveCompanyEmailDomainsData,
  RemoveCompanyEmailDomainsError,
  RemoveCompanyEmailDomainsResponse,
  AddCompanyEmailDomainsData,
  AddCompanyEmailDomainsError,
  AddCompanyEmailDomainsResponse,
  UploadCompanyImageData,
  UploadCompanyImageError,
  UploadCompanyImageResponse,
  ListUsersinaCompanyData,
  ListUsersinaCompanyError,
  ListUsersinaCompanyResponse,
  AddUserstoCompanyData,
  AddUserstoCompanyError,
  AddUserstoCompanyResponse,
  RemoveUsersfromCompanyData,
  RemoveUsersfromCompanyError,
  RemoveUsersfromCompanyResponse,
  RemoveUserfromtheCompanyData,
  RemoveUserfromtheCompanyError,
  RemoveUserfromtheCompanyResponse,
  UpdateUserintheCompanyData,
  UpdateUserintheCompanyError,
  UpdateUserintheCompanyResponse,
  UploadFileData,
  UploadFileError,
  UploadFileResponse,
  CreateNewExportRequestData,
  CreateNewExportRequestError,
  CreateNewExportRequestResponse,
  GetExportDetailsData,
  GetExportDetailsError,
  GetExportDetailsResponse,
  ListSupported2D3dSpatialfileformatsData,
  ListSupported2D3dSpatialfileformatsError,
  ListSupported2D3dSpatialfileformatsResponse,
  CommitFileUploadData,
  CommitFileUploadError,
  CommitFileUploadResponse,
  InitiateFileUploadData,
  InitiateFileUploadError,
  InitiateFileUploadResponse,
  GetActiveFileFolderSnapshotData,
  GetActiveFileFolderSnapshotError,
  GetActiveFileFolderSnapshotResponse,
  GetFileUploadDetailsData,
  GetFileUploadDetailsError,
  GetFileUploadDetailsResponse,
  InitiateFilePackageUploadData,
  InitiateFilePackageUploadError,
  InitiateFilePackageUploadResponse,
  CompleteMultipartFileUploadData,
  CompleteMultipartFileUploadError,
  CompleteMultipartFileUploadResponse,
  GetFileUploadStatusData,
  GetFileUploadStatusError,
  GetFileUploadStatusResponse,
  DownloadUrlData,
  DownloadUrlError,
  DownloadUrlResponse,
  GetFileDetailsData,
  GetFileDetailsError,
  GetFileDetailsResponse,
  DeleteFileData,
  DeleteFileError,
  DeleteFileResponse,
  UpdateFileDetailsData,
  UpdateFileDetailsError,
  UpdateFileDetailsResponse,
  GetalignmentData,
  GetalignmentError,
  GetalignmentResponse2,
  CreateAlignmentData,
  CreateAlignmentError,
  CreateAlignmentResponse,
  DeletealignmentData,
  DeletealignmentError,
  DeletealignmentResponse,
  CreatealignmentwithmatrixData,
  CreatealignmentwithmatrixError,
  CreatealignmentwithmatrixResponse,
  CheckinFileData,
  CheckinFileError,
  CheckinFileResponse,
  CheckoutFileData,
  CheckoutFileError,
  CheckoutFileResponse,
  DownloadFileData,
  DownloadFileError,
  DownloadFileResponse,
  GetFilePermissionsData,
  GetFilePermissionsError,
  GetFilePermissionsResponse,
  PatchFilePermissionsData,
  PatchFilePermissionsError,
  PatchFilePermissionsResponse,
  GetprocessingstatusofaFileData,
  GetprocessingstatusofaFileError,
  GetprocessingstatusofaFileResponse2,
  GetversionsofaFileData,
  GetversionsofaFileError,
  GetversionsofaFileResponse,
  CreateaNewFolderData,
  CreateaNewFolderError,
  CreateaNewFolderResponse,
  ListItemsinaFolderbypathData,
  ListItemsinaFolderbypathError,
  ListItemsinaFolderbypathResponse,
  GetFolderDetailsData,
  GetFolderDetailsError,
  GetFolderDetailsResponse,
  DeleteFolderData,
  DeleteFolderError,
  DeleteFolderResponse,
  UpdateFolderData,
  UpdateFolderError,
  UpdateFolderResponse,
  GetFileFolderDetailsByNameData,
  GetFileFolderDetailsByNameError,
  GetFileFolderDetailsByNameResponse,
  ListItemsinaFolderData,
  ListItemsinaFolderError,
  ListItemsinaFolderResponse2,
  GetFolderPermissionsData,
  GetFolderPermissionsError,
  GetFolderPermissionsResponse,
  AddaNewFolderPermissionData,
  AddaNewFolderPermissionError,
  AddaNewFolderPermissionResponse,
  RemoveanyexistingFolderPermissionData,
  RemoveanyexistingFolderPermissionError,
  RemoveanyexistingFolderPermissionResponse,
  UpdateexistingFolderPermissionData,
  UpdateexistingFolderPermissionError,
  UpdateexistingFolderPermissionResponse,
  GetversionsofaFolderData,
  GetversionsofaFolderError,
  GetversionsofaFolderResponse,
  ListGroupsinaprojectData,
  ListGroupsinaprojectError,
  ListGroupsinaprojectResponse,
  CreateaNewGroupData,
  CreateaNewGroupError,
  CreateaNewGroupResponse,
  GetGroupDetailsData,
  GetGroupDetailsError,
  GetGroupDetailsResponse,
  DeleteGroupData,
  DeleteGroupError,
  DeleteGroupResponse,
  RenameGroupData,
  RenameGroupError,
  RenameGroupResponse,
  ListUsersinaGroupData,
  ListUsersinaGroupError,
  ListUsersinaGroupResponse,
  AdduserstogroupData,
  AdduserstogroupError,
  AdduserstogroupResponse,
  DeleteusersfromgroupData,
  DeleteusersfromgroupError,
  DeleteusersfromgroupResponse,
  ListlinkedentitiesforobjectsData,
  ListlinkedentitiesforobjectsError,
  ListlinkedentitiesforobjectsResponse,
  CreateobjectlinkData,
  CreateobjectlinkError,
  CreateobjectlinkResponse,
  BulkcreateobjectlinksData,
  BulkcreateobjectlinksError,
  BulkcreateobjectlinksResponse,
  ListlinksforthegiventargetentityData,
  ListlinksforthegiventargetentityError,
  ListlinksforthegiventargetentityResponse,
  DeleteaobjectlinkData,
  DeleteaobjectlinkError,
  DeleteaobjectlinkResponse,
  UpdateobjectlinksData,
  UpdateobjectlinksError,
  UpdateobjectlinksResponse,
  ListallProjectsData,
  ListallProjectsError,
  ListallProjectsResponse,
  CreateaNewProjectData,
  CreateaNewProjectError,
  CreateaNewProjectResponse,
  RequestProjectAccessData,
  RequestProjectAccessError,
  RequestProjectAccessResponse,
  CloneProjectData,
  CloneProjectError,
  CloneProjectResponse,
  GetProjectCloneDetailsData,
  GetProjectCloneDetailsError,
  GetProjectCloneDetailsResponse,
  ListAllProjectsMiniError,
  ListAllProjectsMiniResponse,
  GetProjectDetailsData,
  GetProjectDetailsError,
  GetProjectDetailsResponse,
  DeleteProjectData,
  DeleteProjectError,
  DeleteProjectResponse,
  UpdateProjectData,
  UpdateProjectError,
  UpdateProjectResponse,
  UploadProjectImageData,
  UploadProjectImageError,
  UploadProjectImageResponse,
  GetProjectlicensedetailsData,
  GetProjectlicensedetailsError,
  GetProjectlicensedetailsResponse,
  UpdateProjectLicenseDetailsData,
  UpdateProjectLicenseDetailsError,
  UpdateProjectLicenseDetailsResponse,
  GetProjectMetricsData,
  GetProjectMetricsError,
  GetProjectMetricsResponse,
  GetProjectSyncObjectsData,
  GetProjectSyncObjectsError,
  GetProjectSyncObjectsResponse,
  ListrolesavailableinprojectData,
  ListrolesavailableinprojectError,
  ListrolesavailableinprojectResponse,
  GetProjectsettingsData,
  GetProjectsettingsError,
  GetProjectsettingsResponse,
  UpdateProjectSettingsData,
  UpdateProjectSettingsError,
  UpdateProjectSettingsResponse,
  GetProjectSyncStatusData,
  GetProjectSyncStatusError,
  GetProjectSyncStatusResponse,
  ListallUsersinprojectData,
  ListallUsersinprojectError,
  ListallUsersinprojectResponse,
  AddInviteUserstoprojectData,
  AddInviteUserstoprojectError,
  AddInviteUserstoprojectResponse,
  GetProjectUserDetailsData,
  GetProjectUserDetailsError,
  GetProjectUserDetailsResponse,
  RemoveuserData,
  RemoveuserError,
  RemoveuserResponse,
  UpdateUserroleData,
  UpdateUserroleError,
  UpdateUserroleResponse,
  GetAvailableRegionsError,
  GetAvailableRegionsResponse2,
  ListallReleasesData,
  ListallReleasesError,
  ListallReleasesResponse,
  CreateaNewReleaseData,
  CreateaNewReleaseError,
  CreateaNewReleaseResponse,
  DownloadfilesinreleaseData,
  DownloadfilesinreleaseError,
  DownloadfilesinreleaseResponse,
  GetReleaseDetailsData,
  GetReleaseDetailsError,
  GetReleaseDetailsResponse,
  DeleteReleaseData,
  DeleteReleaseError,
  DeleteReleaseResponse,
  EditReleaseData,
  EditReleaseError,
  EditReleaseResponse,
  ListallfilesData,
  ListallfilesError,
  ListallfilesResponse,
  AddfilesData,
  AddfilesError,
  AddfilesResponse,
  RemovefilesData,
  RemovefilesError,
  RemovefilesResponse,
  ListAllSearchResultsData,
  ListAllSearchResultsError,
  ListAllSearchResultsResponse2,
  ListallSharesData,
  ListallSharesError,
  ListallSharesResponse,
  CreateaNewShareData,
  CreateaNewShareError,
  CreateaNewShareResponse,
  GetShareDetailsWithAccessTokenUsingStokenData,
  GetShareDetailsWithAccessTokenUsingStokenError,
  GetShareDetailsWithAccessTokenUsingStokenResponse,
  GetShareDetailsData,
  GetShareDetailsError,
  GetShareDetailsResponse,
  DeleteShareData,
  DeleteShareError,
  DeleteShareResponse,
  EditShareData,
  EditShareError,
  EditShareResponse,
  ListTagsinaprojectData,
  ListTagsinaprojectError,
  ListTagsinaprojectResponse,
  CreateTagData,
  CreateTagError,
  CreateTagResponse,
  GetTagDetailsData,
  GetTagDetailsError,
  GetTagDetailsResponse,
  DeleteTagData,
  DeleteTagError,
  DeleteTagResponse,
  EditTagData,
  EditTagError,
  EditTagResponse,
  ListobjectsinaTagData,
  ListobjectsinaTagError,
  ListobjectsinaTagResponse,
  AddobjectstoTagData,
  AddobjectstoTagError,
  AddobjectstoTagResponse,
  RemoveobjectsfromTagData,
  RemoveobjectsfromTagError,
  RemoveobjectsfromTagResponse,
  ListallToDosData,
  ListallToDosError,
  ListallToDosResponse,
  CreateaNewToDoData,
  CreateaNewToDoError,
  CreateaNewToDoResponse,
  ListallTodoTypesofaProjectData,
  ListallTodoTypesofaProjectError,
  ListallTodoTypesofaProjectResponse,
  GetToDoDetailsData,
  GetToDoDetailsError,
  GetToDoDetailsResponse,
  DeleteToDoData,
  DeleteToDoError,
  DeleteToDoResponse,
  UpdateToDoData,
  UpdateToDoError,
  UpdateToDoResponse,
  ListallattachmentsData,
  ListallattachmentsError,
  ListallattachmentsResponse,
  AddattachmentsData,
  AddattachmentsError,
  AddattachmentsResponse,
  RemoveattachmentsData,
  RemoveattachmentsError,
  RemoveattachmentsResponse,
  ListAllSupportedLanguagesError,
  ListAllSupportedLanguagesResponse,
  ListUserLicensesError,
  ListUserLicensesResponse,
  ListAllAvailableTimezonesError,
  ListAllAvailableTimezonesResponse,
  GetUserDetailsData,
  GetUserDetailsError,
  GetUserDetailsResponse2,
  UpdateUserDetailsData,
  UpdateUserDetailsError,
  UpdateUserDetailsResponse,
  ListallViewGroupsData,
  ListallViewGroupsError,
  ListallViewGroupsResponse,
  CreateaViewGroupData,
  CreateaViewGroupError,
  CreateaViewGroupResponse,
  GetViewGroupDetailsData,
  GetViewGroupDetailsError,
  GetViewGroupDetailsResponse,
  DeleteViewGroupData,
  DeleteViewGroupError,
  DeleteViewGroupResponse,
  UpdateViewGroupDetailsData,
  UpdateViewGroupDetailsError,
  UpdateViewGroupDetailsResponse,
  ListallViewsinaprojectData,
  ListallViewsinaprojectError,
  ListallViewsinaprojectResponse,
  CreateViewData,
  CreateViewError,
  CreateViewResponse,
  CreateViewWithThumbnailData,
  CreateViewWithThumbnailError,
  CreateViewWithThumbnailResponse,
  UpdateViewWithThumbnailData,
  UpdateViewWithThumbnailError,
  UpdateViewWithThumbnailResponse,
  GetViewDetailsData,
  GetViewDetailsError,
  GetViewDetailsResponse,
  DeleteViewData,
  DeleteViewError,
  DeleteViewResponse,
  UpdateViewData,
  UpdateViewError,
  UpdateViewResponse,
  GetCameraDetailsData,
  GetCameraDetailsError,
  GetCameraDetailsResponse,
  UpdateCameraData,
  UpdateCameraError,
  UpdateCameraResponse,
  GetViewImageData,
  GetViewImageError,
  GetViewImageResponse,
  UploadViewThumbnailImageData,
  UploadViewThumbnailImageError,
  UploadViewThumbnailImageResponse2,
  ListMarkupsData,
  ListMarkupsError,
  ListMarkupsResponse,
  CreateMarkupsData,
  CreateMarkupsError,
  CreateMarkupsResponse,
  UpdateMarkupData,
  UpdateMarkupError,
  UpdateMarkupResponse,
  DeleteMarkupData,
  DeleteMarkupError,
  DeleteMarkupResponse,
  GetPresentationData,
  GetPresentationError,
  GetPresentationResponse,
  UpdatePresentationData,
  UpdatePresentationError,
  UpdatePresentationResponse,
  ListSectionPlanesData,
  ListSectionPlanesError,
  ListSectionPlanesResponse,
  CreateSectionPlaneData,
  CreateSectionPlaneError,
  CreateSectionPlaneResponse,
  UpdateSectionPlaneData,
  UpdateSectionPlaneError,
  UpdateSectionPlaneResponse,
  DeleteSectionPlaneData,
  DeleteSectionPlaneError,
  DeleteSectionPlaneResponse,
  Listall2dViewsData,
  Listall2dViewsError,
  Listall2dViewsResponse,
  CreateaNew2dViewData,
  CreateaNew2dViewError,
  CreateaNew2dViewResponse,
  Createa2dViewMultipartData,
  Createa2dViewMultipartError,
  Createa2dViewMultipartResponse,
  Update2dViewMultipartData,
  Update2dViewMultipartError,
  Update2dViewMultipartResponse,
  Get2dViewdetailsData,
  Get2dViewdetailsError,
  Get2dViewdetailsResponse,
  Delete2dViewData,
  Delete2dViewError,
  Delete2dViewResponse,
  Update2dViewData,
  Update2dViewError,
  Update2dViewResponse,
} from './types.gen';

/**
 * List Activities of a Project / Object
 * API to list the activities in a project / specific object
 */
export const listActivitiesofaProjectObject = (
  options: Options<ListActivitiesofaProjectObjectData>
) => {
  return (options?.client ?? client).get<
    ListActivitiesofaProjectObjectResponse,
    ListActivitiesofaProjectObjectError
  >({
    ...options,
    url: '/activities',
  });
};

/**
 * Create a new export Request
 * This API is used to create export Request for activities in a project.
 */
export const postCreateanewexportRequest = (
  options: Options<PostCreateanewexportRequestData>
) => {
  return (options?.client ?? client).post<
    PostCreateanewexportRequestResponse,
    PostCreateanewexportRequestError
  >({
    ...options,
    url: '/activities/exports',
  });
};

/**
 * Get export details
 * API to fetch details of the export activities.
 */
export const getExportdetails = (options: Options<GetExportdetailsData>) => {
  return (options?.client ?? client).get<
    GetExportdetailsResponse,
    GetExportdetailsError
  >({
    ...options,
    url: '/activities/exports/{exportId}',
  });
};

/**
 * List activities with filters
 * This API is used to list activities with filters.The `filters` in the request body can be used to filter the list of activities by a start and end date, by list of users or usergroups who performed actions that created the activities, and by list of activity types.  <br> This API can also be used to list activities by specific objectId and objectType by using the query parameters. <br> This API uses cursor based pagination (see `lastId` and `pageSize` query params) and does not support range headers.
 */
export const postActivitiesList = (
  options: Options<PostActivitiesListData>
) => {
  return (options?.client ?? client).post<
    PostActivitiesListResponse,
    PostActivitiesListError
  >({
    ...options,
    url: '/activities/list',
  });
};

/**
 * Activity Details by activityId
 * API to fetch details an activity by id
 */
export const activityDetailsbyactivityId = (
  options: Options<ActivityDetailsbyactivityIdData>
) => {
  return (options?.client ?? client).get<
    ActivityDetailsbyactivityIdResponse,
    ActivityDetailsbyactivityIdError
  >({
    ...options,
    url: '/activities/{activityId}',
  });
};

/**
 * Activity logs by activityId
 * API to fetch list of logs of an activity by id
 */
export const activitylogsbyactivityId = (
  options: Options<ActivitylogsbyactivityIdData>
) => {
  return (options?.client ?? client).get<
    ActivitylogsbyactivityIdResponse,
    ActivitylogsbyactivityIdError
  >({
    ...options,
    url: '/activities/{activityId}/logs',
  });
};

/**
 * List all Clashes in a project
 * List all Clashes in a project
 */
export const listallClashesinaproject = (
  options: Options<ListallClashesinaprojectData>
) => {
  return (options?.client ?? client).get<
    ListallClashesinaprojectResponse,
    ListallClashesinaprojectError
  >({
    ...options,
    url: '/clashsets',
  });
};

/**
 * Create a New Clash
 * You can create a new Clash Report using this action.
 */
export const createaNewClash = (options: Options<CreateaNewClashData>) => {
  return (options?.client ?? client).post<
    CreateaNewClashResponse,
    CreateaNewClashError
  >({
    ...options,
    url: '/clashsets',
  });
};

/**
 * Get Clash Details
 * Get Clash Details
 */
export const getClashDetails = (options: Options<GetClashDetailsData>) => {
  return (options?.client ?? client).get<
    GetClashDetailsResponse,
    GetClashDetailsError
  >({
    ...options,
    url: '/clashsets/{clashId}',
  });
};

/**
 * Delete a Clash
 * Delete a Clash
 */
export const deleteClash = (options: Options<DeleteClashData>) => {
  return (options?.client ?? client).delete<
    DeleteClashResponse,
    DeleteClashError
  >({
    ...options,
    url: '/clashsets/{clashId}',
  });
};

/**
 * Update Clash
 * This API allows you to update the following properties of the Clash:
 *
 * - name
 *
 * - assignees
 */
export const updateClash = (options: Options<UpdateClashData>) => {
  return (options?.client ?? client).patch<
    UpdateClashResponse,
    UpdateClashError
  >({
    ...options,
    url: '/clashsets/{clashId}',
  });
};

/**
 * List All Clash Items
 * This API returns a list of clash-items in the Clash.
 * **Note** : The center point will not be present for clash-items of legacy viewer(BSQ) based clashsets.
 */
export const listAllClashItems = (options: Options<ListAllClashItemsData>) => {
  return (options?.client ?? client).get<
    ListAllClashItemsResponse2,
    ListAllClashItemsError
  >({
    ...options,
    url: '/clashsets/{clashId}/items',
  });
};

/**
 * List all Comments
 * List all Comments
 */
export const listallComments = (options: Options<ListallCommentsData>) => {
  return (options?.client ?? client).get<
    ListallCommentsResponse,
    ListallCommentsError
  >({
    ...options,
    url: '/comments',
  });
};

/**
 * Create a New Comment
 * You may create a new Comment using this action.
 *
 * + description (string) - The details of the Comment
 *
 * + objectId (string) - Object Identifier
 *
 * + objectType (string) - Object Type
 *
 * + contextId (string) - The unique identifier of the context in TRN format (trn:2:tc:{us|eu|ap|ap-au}:projects:{projectId}:files:{fileId}). Mandatory for objectType ISSUE.
 *
 * Valid values for **objectType** are:
 *
 * - FILE
 *
 * - FOLDER
 *
 * - VIEW
 *
 * - CLASH
 *
 * - RELEASE
 *
 * - TODO
 *
 * - ISSUE
 */
export const createaNewComment = (options: Options<CreateaNewCommentData>) => {
  return (options?.client ?? client).post<
    CreateaNewCommentResponse,
    CreateaNewCommentError
  >({
    ...options,
    url: '/comments',
  });
};

/**
 * Get Comment Details
 * Get Comment Details
 */
export const getCommentDetails = (options: Options<GetCommentDetailsData>) => {
  return (options?.client ?? client).get<
    GetCommentDetailsResponse,
    GetCommentDetailsError
  >({
    ...options,
    url: '/comments/{commentId}',
  });
};

/**
 * Delete a Comment
 * Delete a Comment
 */
export const deleteComment = (options: Options<DeleteCommentData>) => {
  return (options?.client ?? client).delete<
    DeleteCommentResponse,
    DeleteCommentError
  >({
    ...options,
    url: '/comments/{commentId}',
  });
};

/**
 * Update Comment
 * This API allows you to update description of the Comment:
 */
export const updateComment = (options: Options<UpdateCommentData>) => {
  return (options?.client ?? client).patch<
    UpdateCommentResponse,
    UpdateCommentError
  >({
    ...options,
    url: '/comments/{commentId}',
  });
};

/**
 * List all attachments
 * These set of APIs allow you to list attachments to a Comment.
 */
export const getListallattachments = (
  options: Options<GetListallattachmentsData>
) => {
  return (options?.client ?? client).get<
    GetListallattachmentsResponse,
    GetListallattachmentsError
  >({
    ...options,
    url: '/comments/{commentId}/attachments',
  });
};

/**
 * Add attachments
 * These set of APIs allow you to add attachments to a Comment.
 *
 * Valid values for **type** are:
 *
 * - FILE
 *
 * - VIEW
 *
 * - URL
 *
 * - VIEW2D
 *
 * - CLASHITEM
 */
export const postAddattachments = (
  options: Options<PostAddattachmentsData>
) => {
  return (options?.client ?? client).post<
    PostAddattachmentsResponse,
    PostAddattachmentsError
  >({
    ...options,
    url: '/comments/{commentId}/attachments',
  });
};

/**
 * Remove attachments
 * These set of APIs allow you to remove attachments to a Comment.
 *
 * This api takes request body as given below <br/>
 * [ <br/>
 * { <br/>
 * "id": "woC32em2Fb0",<br/>
 * "type": "FILE"<br/>
 * }<br/>
 * ]
 */
export const deleteRemoveattachments = (
  options: Options<DeleteRemoveattachmentsData>
) => {
  return (options?.client ?? client).delete<
    DeleteRemoveattachmentsResponse,
    DeleteRemoveattachmentsError
  >({
    ...options,
    url: '/comments/{commentId}/attachments',
  });
};

/**
 * List reactions to a comment
 * List reactions to a comment. Cursor based pagination is used with optional `pageSize` query params. The default value of `pageSize` is 100.
 *
 * **Note:** The result items might not have the same count as in `pageSize`. The client must keep paginating until the `links.next` is empty in the response.
 */
export const listReactionsToComment = (
  options: Options<ListReactionsToCommentData>
) => {
  return (options?.client ?? client).get<
    ListReactionsToCommentResponse,
    ListReactionsToCommentError
  >({
    ...options,
    url: '/comments/{commentId}/reactions',
  });
};

/**
 * Adds user's reaction to a comment
 * Add user's reaction to a comment. Multiple different reactons are allowed, but not duplicates of the same reaction for the same user.
 */
export const addReactionToComment = (
  options: Options<AddReactionToCommentData>
) => {
  return (options?.client ?? client).post<
    AddReactionToCommentResponse2,
    AddReactionToCommentError
  >({
    ...options,
    url: '/comments/{commentId}/reactions',
  });
};

/**
 * Delete users reaction to a comment
 * Removes user reaction to a comment. The deletion is hard, meaning the delete operation is undoable.
 */
export const deleteReactionToComment = (
  options: Options<DeleteReactionToCommentData>
) => {
  return (options?.client ?? client).delete<
    DeleteReactionToCommentResponse,
    DeleteReactionToCommentError
  >({
    ...options,
    url: '/comments/{commentId}/reactions/{reactionId}',
  });
};

/**
 * @deprecated
 * List Companies
 * Company user can get the list of associated companies.
 */
export const listCompanies = (options?: Options) => {
  return (options?.client ?? client).get<
    ListCompaniesResponse,
    ListCompaniesError
  >({
    ...options,
    url: '/companies',
  });
};

/**
 * @deprecated
 * Get Company Details
 * API for company user/admin to get details of a company.
 */
export const getCompanyDetails = (options: Options<GetCompanyDetailsData>) => {
  return (options?.client ?? client).get<
    GetCompanyDetailsResponse,
    GetCompanyDetailsError
  >({
    ...options,
    url: '/companies/{companyId}',
  });
};

/**
 * @deprecated
 * Update Company
 * The company admin can update the company name, website and domains of the company.
 */
export const updateCompany = (options: Options<UpdateCompanyData>) => {
  return (options?.client ?? client).patch<
    UpdateCompanyResponse,
    UpdateCompanyError
  >({
    ...options,
    url: '/companies/{companyId}',
  });
};

/**
 * @deprecated
 * Remove Company Email Domains
 * API for company admin to remove email domains from company.
 */
export const removeCompanyEmailDomains = (
  options: Options<RemoveCompanyEmailDomainsData>
) => {
  return (options?.client ?? client).delete<
    RemoveCompanyEmailDomainsResponse,
    RemoveCompanyEmailDomainsError
  >({
    ...options,
    url: '/companies/{companyId}/domains',
  });
};

/**
 * @deprecated
 * Add Company Email Domains
 * The company admin can update the company email domains. The entries will append to the existing domains.
 */
export const addCompanyEmailDomains = (
  options: Options<AddCompanyEmailDomainsData>
) => {
  return (options?.client ?? client).patch<
    AddCompanyEmailDomainsResponse,
    AddCompanyEmailDomainsError
  >({
    ...options,
    url: '/companies/{companyId}/domains',
  });
};

/**
 * @deprecated
 * Upload Company Image
 * API for company admin to update the company logo by uploading an image file.
 */
export const uploadCompanyImage = (
  options: Options<UploadCompanyImageData>
) => {
  return (options?.client ?? client).post<
    UploadCompanyImageResponse,
    UploadCompanyImageError
  >({
    ...options,
    url: '/companies/{companyId}/image',
  });
};

/**
 * @deprecated
 * List Users in a Company
 * API for company user/admin to list users in the company.
 */
export const listUsersinaCompany = (
  options: Options<ListUsersinaCompanyData>
) => {
  return (options?.client ?? client).get<
    ListUsersinaCompanyResponse,
    ListUsersinaCompanyError
  >({
    ...options,
    url: '/companies/{companyId}/users',
  });
};

/**
 * @deprecated
 * Add Users to Company
 * API for company admin to add users to the company.
 */
export const addUserstoCompany = (options: Options<AddUserstoCompanyData>) => {
  return (options?.client ?? client).post<
    AddUserstoCompanyResponse,
    AddUserstoCompanyError
  >({
    ...options,
    url: '/companies/{companyId}/users',
  });
};

/**
 * @deprecated
 * Remove Users from Company
 * API for company admin to remove users from the company.
 */
export const removeUsersfromCompany = (
  options: Options<RemoveUsersfromCompanyData>
) => {
  return (options?.client ?? client).delete<
    RemoveUsersfromCompanyResponse,
    RemoveUsersfromCompanyError
  >({
    ...options,
    url: '/companies/{companyId}/users',
  });
};

/**
 * @deprecated
 * Remove User from the Company
 * API for company admin to remove the specified user from the company.
 */
export const removeUserfromtheCompany = (
  options: Options<RemoveUserfromtheCompanyData>
) => {
  return (options?.client ?? client).delete<
    RemoveUserfromtheCompanyResponse,
    RemoveUserfromtheCompanyError
  >({
    ...options,
    url: '/companies/{companyId}/users/{userId}',
  });
};

/**
 * @deprecated
 * Update User in the Company
 * API to change the role of the user in the company.
 */
export const updateUserintheCompany = (
  options: Options<UpdateUserintheCompanyData>
) => {
  return (options?.client ?? client).patch<
    UpdateUserintheCompanyResponse,
    UpdateUserintheCompanyError
  >({
    ...options,
    url: '/companies/{companyId}/users/{userId}',
  });
};

/**
 * Copy the File
 * Creates a copy of the file from existing file with the parameters `fromFileVersionId`, `parentId`, `parentType`, `copyMetaData`, `mergeExisting`.
 *
 * ***
 *
 * **The use of this API to upload a new file is deprecated. Use `POST /files/fs/initiate`**
 * **You can upload multiple files using this action. You can use same API to upload new versions of the file.**
 */
export const uploadFile = (options?: Options<UploadFileData>) => {
  return (options?.client ?? client).post<UploadFileResponse, UploadFileError>({
    ...options,
    url: '/files',
  });
};

/**
 * Create a new export Request
 * This API is used to create export Request for files in a project.
 */
export const createNewExportRequest = (
  options: Options<CreateNewExportRequestData>
) => {
  return (options?.client ?? client).post<
    CreateNewExportRequestResponse,
    CreateNewExportRequestError
  >({
    ...options,
    url: '/files/export',
  });
};

/**
 * Get export details
 * API to fetch details of the export activities.
 */
export const getExportDetails = (options: Options<GetExportDetailsData>) => {
  return (options?.client ?? client).get<
    GetExportDetailsResponse,
    GetExportDetailsError
  >({
    ...options,
    url: '/files/export/{exportId}',
  });
};

/**
 * List Supported 2D, 3D & Spatial file formats
 * API to list supported 2D, 3D & spatial file formats.
 */
export const listSupported2d3dSpatialfileformats = (
  options?: Options<ListSupported2D3dSpatialfileformatsData>
) => {
  return (options?.client ?? client).get<
    ListSupported2D3dSpatialfileformatsResponse,
    ListSupported2D3dSpatialfileformatsError
  >({
    ...options,
    url: '/files/formats',
  });
};

/**
 * @deprecated
 * Commit File Upload
 * After the content upload is completed, this API is called to complete the process and create file entity in TC.<br/><br/>The md5 of the file is required in the **digest** header for Multipart upload commits.
 */
export const commitFileUpload = (options: Options<CommitFileUploadData>) => {
  return (options?.client ?? client).post<
    CommitFileUploadResponse,
    CommitFileUploadError
  >({
    ...options,
    url: '/files/fs/commit',
  });
};

/**
 * @deprecated
 * Initiate File upload
 * **This API functionality is now supported by Package File Upload API**<br></br>These API support file uploads via presigned URL. 3 Steps include initiate upload, stream content and commit the upload process.Upload the content with the presigned url obtained from the Response of this API. Use PUT on the url from the Response to upload file content(no other parameters/headers required)<br/><br/> Multipart uploads require numberofparts and size as mandatory and it will result in list of upload URLs along with the part number. Each part in a multipart upload must be between 5 MiB (5,242,880 bytes) and 5 GiB (5,368,709,120 bytes). The last part can be smaller than 5 MiB (5,242,880 bytes). In general, part sizes should be as large as possible. Each part should be upload to corresponding part upload urls. <br/><br/> Multifile feature used to manage a collection of file objects as a single file resource is supported<br/> <br/>   The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version.<br/>  <br/>  If versionId provided in the **If-Match** header is not latest, error Response with Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &        **Error Message**: If-Match header value is not latest versionId.<br/> <br/>    If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 */
export const initiateFileUpload = (
  options?: Options<InitiateFileUploadData>
) => {
  return (options?.client ?? client).post<
    InitiateFileUploadResponse,
    InitiateFileUploadError
  >({
    ...options,
    url: '/files/fs/initiate',
  });
};

/**
 * Get the latest files and folders structure
 * This API retrieves the latest state of files and folders in a project.
 */
export const getActiveFileFolderSnapshot = (
  options: Options<GetActiveFileFolderSnapshotData>
) => {
  return (options?.client ?? client).get<
    GetActiveFileFolderSnapshotResponse,
    GetActiveFileFolderSnapshotError
  >({
    ...options,
    url: '/files/fs/snapshot',
  });
};

/**
 * Get File Upload Details
 * File upload details contains file name, parent information and uploadUrl. This api also provides the file upload status.
 */
export const getFileUploadDetails = (
  options: Options<GetFileUploadDetailsData>
) => {
  return (options?.client ?? client).get<
    GetFileUploadDetailsResponse,
    GetFileUploadDetailsError
  >({
    ...options,
    url: '/files/fs/upload',
  });
};

/**
 * Package File upload
 * This API is used to initiate the file upload. The file stream should be uploaded to the upload URL received in the response with the PUT operation and no additional headers including Authorization to be sent. You can use Get File Upload Details API to check the upload status after initiating the upload.</br> </br>This API can be used to upload files and their representation formats (like  thumbnail, TRB, PDF) as a single package. The API supports multipart and multifile uploads. Multipart upload requires the multipart flag to be passed as true in FileUploadContentDto and size of the file is mandatory to be passed for multipart upload. You should replace the * in the pre-signed url received in response with the part number while uploading the parts. If the file content size is greater than 5GB,it should be uploaded as multipart. Multipart file upload is supported only for source file. You should call the upload complete API after uploading all the parts.<br></br>Multi File/ fileset (upload a set of files in an archived format) is supported by passing the fileset and path template in FileUploadContentDto. Multipart upload is supported for filesets (multifiles).<br></br>Some combinations of file types in package upload may not be supported based on the model file format. Currently Source + TRB and Source + TRB + THUMB are not supported for drawing file formats (such as DWG / DXF).<br></br> Please make sure to upload the object only once to each uploadUrl (retries can be done in case of network related failures). If several successful uploads are executed to the the same uploadUrl, the random content from one of the uploads will be picked up for the permanent storage.</br></br> **Please note that the upload will be marked as EXPIRED if file content is not uploaded within 90 minutes for the single part upload and within 30 minutes for the mutlipart upload(after the complete API is called)**
 */
export const initiateFilePackageUpload = (
  options: Options<InitiateFilePackageUploadData>
) => {
  return (options?.client ?? client).post<
    InitiateFilePackageUploadResponse,
    InitiateFilePackageUploadError
  >({
    ...options,
    url: '/files/fs/upload',
  });
};

/**
 * Complete a multipart file upload
 * Complete a multipart file upload when all parts of a multipart upload has been uploaded for a format
 */
export const completeMultipartFileUpload = (
  options: Options<CompleteMultipartFileUploadData>
) => {
  return (options?.client ?? client).post<
    CompleteMultipartFileUploadResponse,
    CompleteMultipartFileUploadError
  >({
    ...options,
    url: '/files/fs/upload/{uploadId}/complete',
  });
};

/**
 * @deprecated
 * Representation File upload status
 * Upload status of a file and committing representation upload
 */
export const getFileUploadStatus = (
  options: Options<GetFileUploadStatusData>
) => {
  return (options?.client ?? client).get<
    GetFileUploadStatusResponse,
    GetFileUploadStatusError
  >({
    ...options,
    url: '/files/fs/uploadstatus',
  });
};

/**
 * Download URL
 * You can retrieve download URL for a single file using this action. (Part downloads supported with range headers). Use GET on the url from the Response to download file content (no other parameters/headers required)
 *
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are downloading on the latest version.
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 */
export const downloadUrl = (options: Options<DownloadUrlData>) => {
  return (options?.client ?? client).get<DownloadUrlResponse, DownloadUrlError>(
    {
      ...options,
      url: '/files/fs/{fileId}/downloadurl',
    }
  );
};

/**
 * Get File Details
 * This API will fetch the latest version details for the given file Id.
 *
 * To fetch a specific version information, optional query parameter __versionId__ can be specified.
 */
export const getFileDetails = (options: Options<GetFileDetailsData>) => {
  return (options?.client ?? client).get<
    GetFileDetailsResponse,
    GetFileDetailsError
  >({
    ...options,
    url: '/files/{fileId}',
  });
};

/**
 * Delete File
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version. (applicable for single file upload, ignored for multiple file upload)
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 *
 * If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 */
export const deleteFile = (options: Options<DeleteFileData>) => {
  return (options?.client ?? client).delete<
    DeleteFileResponse,
    DeleteFileError
  >({
    ...options,
    url: '/files/{fileId}',
  });
};

/**
 * Update File Details
 * You can rename the file using this API. To move the file, change the parentId to the id of the destination folder.
 *
 * In case both parentId and name is provided, move will take precedence before rename.
 *
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version.
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 *
 * If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 */
export const updateFileDetails = (options: Options<UpdateFileDetailsData>) => {
  return (options?.client ?? client).patch<
    UpdateFileDetailsResponse,
    UpdateFileDetailsError
  >({
    ...options,
    url: '/files/{fileId}',
  });
};

/**
 * Get alignment
 * Get the alignment for a given file. If the **versionId** is specified the alignment details for that particular version is retrieved else it will give the alignment details of the latest version.
 *
 * Unit for locationX, locationY and locationZ is **millimeter(mm)**.
 */
export const getalignment = (options: Options<GetalignmentData>) => {
  return (options?.client ?? client).get<
    GetalignmentResponse2,
    GetalignmentError
  >({
    ...options,
    url: '/files/{fileId}/alignment',
  });
};

/**
 * Create Alignment
 * Create or update an alignment for a given file. It is assumed that the vectors axis and refDirection are orthonormal.
 *
 * Response will be HTTP 200 (updated) or 201 (created). It will update or create alignment for the latest version of the file if versionId is not mentioned.
 *
 * Unit for locationX, locationY and locationZ is **millimeter(mm)**.
 */
export const createAlignment = (options: Options<CreateAlignmentData>) => {
  return (options?.client ?? client).put<
    CreateAlignmentResponse,
    CreateAlignmentError
  >({
    ...options,
    url: '/files/{fileId}/alignment',
  });
};

/**
 * Delete alignment
 * Remove alignment associated with a file.  If the **versionId** is presented for a given file version, only alignment associated with that version is removed, otherwise alignments for all version removed.
 */
export const deletealignment = (options: Options<DeletealignmentData>) => {
  return (options?.client ?? client).delete<
    DeletealignmentResponse,
    DeletealignmentError
  >({
    ...options,
    url: '/files/{fileId}/alignment',
  });
};

/**
 * @deprecated
 * Create alignment with matrix
 * Create an alignment for a given file.  This api is deprecated.
 */
export const createalignmentwithmatrix = (
  options: Options<CreatealignmentwithmatrixData>
) => {
  return (options?.client ?? client).post<
    CreatealignmentwithmatrixResponse,
    CreatealignmentwithmatrixError
  >({
    ...options,
    url: '/files/{fileId}/alignment/matrix',
  });
};

/**
 * Checkin File
 * You can checkin (release lock) on a file using this API, so its available for others to update
 */
export const checkinFile = (options: Options<CheckinFileData>) => {
  return (options?.client ?? client).post<
    CheckinFileResponse,
    CheckinFileError
  >({
    ...options,
    url: '/files/{fileId}/checkin',
  });
};

/**
 * Checkout File
 * You can checkout (lock) a file using this API
 */
export const checkoutFile = (options: Options<CheckoutFileData>) => {
  return (options?.client ?? client).post<
    CheckoutFileResponse,
    CheckoutFileError
  >({
    ...options,
    url: '/files/{fileId}/checkout',
  });
};

/**
 * @deprecated
 * Download File
 * You can download a single file using this action.
 *
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version.
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 *
 * If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 */
export const downloadFile = (options: Options<DownloadFileData>) => {
  return (options?.client ?? client).get<
    DownloadFileResponse,
    DownloadFileError
  >({
    ...options,
    url: '/files/{fileId}/content',
  });
};

/**
 * Get File Permissions
 * This API gives the access control lists (ACLs) that specify the permissions for users and groups associated with a specific file.
 */
export const getFilePermissions = (
  options: Options<GetFilePermissionsData>
) => {
  return (options?.client ?? client).get<
    GetFilePermissionsResponse,
    GetFilePermissionsError
  >({
    ...options,
    url: '/files/{fileId}/permissions',
  });
};

/**
 * Update File Permissions
 * This API is used to add new permissions or update/remove existing permissions for a particular file given as input.<br>If any permissions exist for any users/group, they are removed (reset) and permissions provided in the request body are applied.<br>Input can be an ACL comprising lists of users and groups, with permissions set to either READ or FULL_ACCESS.<br>If the project level setting 'fullAccessIncludesPermissions' is enabled, project users with non admin rights will be able to share files.<br>Additionally, if the project level setting 'allowNonMemberPermissions' is enabled, files can be shared outside project context.
 */
export const patchFilePermissions = (
  options: Options<PatchFilePermissionsData>
) => {
  return (options?.client ?? client).patch<
    PatchFilePermissionsResponse,
    PatchFilePermissionsError
  >({
    ...options,
    url: '/files/{fileId}/permissions',
  });
};

/**
 * Get processing status of a File
 * Returns the format processing status for 2D and 3D files. The valid return values are integer from 0 to 100, negative values indicate processing error.
 *
 * Supported formats are ifc, ifczip, 3dm, obj, skp, fbx, rvt, dwg, dxf, dgn, 3ds, stp, step, iges, igs, stl, doc, docx, xls, xlsx, rtf, txt, ppt, pptx, pdf, jpg, jpeg, gif, png, bmp, jpg, jpeg, gif, png, tif and tiff.
 */
export const getprocessingstatusofaFile = (
  options: Options<GetprocessingstatusofaFileData>
) => {
  return (options?.client ?? client).get<
    GetprocessingstatusofaFileResponse2,
    GetprocessingstatusofaFileError
  >({
    ...options,
    url: '/files/{fileId}/status',
  });
};

/**
 * Get versions of a File
 * Get versions of a File
 */
export const getversionsofaFile = (
  options: Options<GetversionsofaFileData>
) => {
  return (options?.client ?? client).get<
    GetversionsofaFileResponse,
    GetversionsofaFileError
  >({
    ...options,
    url: '/files/{fileId}/versions',
  });
};

/**
 * Create a New Folder
 * You can create a new Folder using this action. It takes a JSON object containing a parent Identifier and a name, both required.
 *
 * + name (string) - The name of the folder
 *
 * + parentId (string) - parent folder's version Id
 *
 * + tags (optional) - List of Tags to be linked with folder
 */
export const createaNewFolder = (options: Options<CreateaNewFolderData>) => {
  return (options?.client ?? client).post<
    CreateaNewFolderResponse,
    CreateaNewFolderError
  >({
    ...options,
    url: '/folders',
  });
};

/**
 * List Items in a Folder by path
 * API returns the list of Folders and Files in the given path in the query parameter
 */
export const listItemsinaFolderbypath = (
  options: Options<ListItemsinaFolderbypathData>
) => {
  return (options?.client ?? client).get<
    ListItemsinaFolderbypathResponse,
    ListItemsinaFolderbypathError
  >({
    ...options,
    url: '/folders/by_path',
  });
};

/**
 * Get Folder Details
 * Get Folder Details
 */
export const getFolderDetails = (options: Options<GetFolderDetailsData>) => {
  return (options?.client ?? client).get<
    GetFolderDetailsResponse,
    GetFolderDetailsError
  >({
    ...options,
    url: '/folders/{folderId}',
  });
};

/**
 * Delete Folder
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version. (applicable for single file upload, ignored for multiple file upload)
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 *
 * If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 */
export const deleteFolder = (options: Options<DeleteFolderData>) => {
  return (options?.client ?? client).delete<
    DeleteFolderResponse,
    DeleteFolderError
  >({
    ...options,
    url: '/folders/{folderId}',
  });
};

/**
 * Update Folder
 * You can use this API to move/rename the Folder.
 *
 * To move a folder, update the parentId attribute.
 * In case both parentId and name is provided, move will take precedence before rename.
 *
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version. (applicable for single file upload, ignored for multiple file upload)
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 *
 * If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 * You can use this API to move/rename the Folder.<br/> <br/> To move a folder, update the parentId attribute.<br/> <br/> In case both parentId and name is provided, move will take precedence before rename. <br/> <br/> The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version. (applicable for single file upload, ignored for multiple file upload) <br/> <br/> If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &  **Error Message**: If-Match header value is not latest versionId. <br/> <br/> If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 */
export const updateFolder = (options: Options<UpdateFolderData>) => {
  return (options?.client ?? client).patch<
    UpdateFolderResponse,
    UpdateFolderError
  >({
    ...options,
    url: '/folders/{folderId}',
  });
};

/**
 * Get File/Folder Details By parent folder id and name
 * Fetches the file/folder details as per the given parent folder id and name that user has access to. If no details present, **NOT_FOUND** exception will be thrown.
 */
export const getFileFolderDetailsByName = (
  options: Options<GetFileFolderDetailsByNameData>
) => {
  return (options?.client ?? client).get<
    GetFileFolderDetailsByNameResponse,
    GetFileFolderDetailsByNameError
  >({
    ...options,
    url: '/folders/{folderId}/item',
  });
};

/**
 * List Items in a Folder
 * List Items in a Folder
 */
export const listItemsinaFolder = (
  options: Options<ListItemsinaFolderData>
) => {
  return (options?.client ?? client).get<
    ListItemsinaFolderResponse2,
    ListItemsinaFolderError
  >({
    ...options,
    url: '/folders/{folderId}/items',
  });
};

/**
 * Get Folder Permissions
 * This API gives a list of Permissions that are applied to a given folder
 */
export const getFolderPermissions = (
  options: Options<GetFolderPermissionsData>
) => {
  return (options?.client ?? client).get<
    GetFolderPermissionsResponse,
    GetFolderPermissionsError
  >({
    ...options,
    url: '/folders/{folderId}/permissions',
  });
};

/**
 * Add a New Folder Permission
 * This API allows to create a new folder Permission for users/groups. If any permissions exist for any users/group, they are removed (reset) and permissions provided in Request body are applied.
 * It can also be used to reset the default permission.
 * It takes optional cascade field to add permissions on subfolders recursively.
 * You can specify the versionId in the If-Match header to validate you are working off the latest version of the folder.
 *
 * This API takes a default permission, propagation flag and a list of Permissions.
 * Each permission has following fields:
 *
 * - id (id of User or Group)
 *
 * - type
 *
 * - permission
 *
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version. (applicable for single file upload, ignored for multiple file upload)
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 *
 * If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 */
export const addaNewFolderPermission = (
  options: Options<AddaNewFolderPermissionData>
) => {
  return (options?.client ?? client).post<
    AddaNewFolderPermissionResponse,
    AddaNewFolderPermissionError
  >({
    ...options,
    url: '/folders/{folderId}/permissions',
  });
};

/**
 * Remove any existing Folder Permission
 * This API allows to removes specified given permission to given user/group and recomputes permission for actor based on user roles and default permission.
 * It takes optional cascade field to delete permissions on subfolders recursively.
 * You can specify the versionId in the If-Match header to validate you are working off the latest version of the folder.
 *
 * This API takes propagation flag and a list of Permissions as a Request Body, each permission has following fields
 *
 * - id (id of User or Group)
 *
 * - type
 *
 * Example : <br/>
 * {<br/>
 * "cascade": "true",<br/>
 * "permissions": [<br/>
 * {<br/>
 * "id": "0Z-OMo67VtY",<br/>
 * "type": "USER"<br/>
 * },<br/>
 * {<br/>
 * "id": "swO2L9AqeT0",<br/>
 * "type": "GROUP"<br/>
 * }<br/>
 * ]<br/>
 * }<br/>
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version. (applicable for single file upload, ignored for multiple file upload)
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 *
 * If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 */
export const removeanyexistingFolderPermission = (
  options: Options<RemoveanyexistingFolderPermissionData>
) => {
  return (options?.client ?? client).delete<
    RemoveanyexistingFolderPermissionResponse,
    RemoveanyexistingFolderPermissionError
  >({
    ...options,
    url: '/folders/{folderId}/permissions',
  });
};

/**
 * Update existing Folder Permission
 * This API allows to update existing folder Permissions or add permissions for new users/groups. It can also be used to reset the default permission.
 * It takes optional cascade field to update permissions on subfolders recursively.
 * You can specify the versionId in the If-Match header to validate you are working off the latest version of the folder.
 * This API takes default permission, propagation flag and a list of Permissions.
 * Each permission has following fields:
 *
 * - id (id of User or Group)
 *
 * - type
 *
 * - permission
 *
 * The API also supports **If-Match** optional header to provide the versionId, so you can verify you are working on the latest version. (applicable for single file upload, ignored for multiple file upload)
 *
 * If versionId provided in the **If-Match** header is not latest, error Response wiith Response code **412** will be send back to the caller with **Errorcode** INVALID_HEADER &
 * **Error Message**: If-Match header value is not latest versionId.
 *
 * If the **If-Match** header value is *  or header not provided, actions will be performed on the latest version.
 */
export const updateexistingFolderPermission = (
  options: Options<UpdateexistingFolderPermissionData>
) => {
  return (options?.client ?? client).patch<
    UpdateexistingFolderPermissionResponse,
    UpdateexistingFolderPermissionError
  >({
    ...options,
    url: '/folders/{folderId}/permissions',
  });
};

/**
 * Get versions of a Folder
 * Get versions of a Folder
 */
export const getversionsofaFolder = (
  options: Options<GetversionsofaFolderData>
) => {
  return (options?.client ?? client).get<
    GetversionsofaFolderResponse,
    GetversionsofaFolderError
  >({
    ...options,
    url: '/folders/{folderId}/versions',
  });
};

/**
 * List Groups in a project
 * List Groups in a project
 */
export const listGroupsinaproject = (
  options: Options<ListGroupsinaprojectData>
) => {
  return (options?.client ?? client).get<
    ListGroupsinaprojectResponse,
    ListGroupsinaprojectError
  >({
    ...options,
    url: '/groups',
  });
};

/**
 * Create a New Group
 * You can create a new group using this action. You need to provide a project id in which the group should be created and group name
 */
export const createaNewGroup = (options: Options<CreateaNewGroupData>) => {
  return (options?.client ?? client).post<
    CreateaNewGroupResponse,
    CreateaNewGroupError
  >({
    ...options,
    url: '/groups',
  });
};

/**
 * Get Group Details
 * Get the details of a group.
 */
export const getGroupDetails = (options: Options<GetGroupDetailsData>) => {
  return (options?.client ?? client).get<
    GetGroupDetailsResponse,
    GetGroupDetailsError
  >({
    ...options,
    url: '/groups/{groupId}',
  });
};

/**
 * Delete Group
 * You can use this API to delete a Group.
 */
export const deleteGroup = (options: Options<DeleteGroupData>) => {
  return (options?.client ?? client).delete<
    DeleteGroupResponse,
    DeleteGroupError
  >({
    ...options,
    url: '/groups/{groupId}',
  });
};

/**
 * Rename Group
 * You can use this API to rename the Group.
 */
export const renameGroup = (options: Options<RenameGroupData>) => {
  return (options?.client ?? client).patch<
    RenameGroupResponse,
    RenameGroupError
  >({
    ...options,
    url: '/groups/{groupId}',
  });
};

/**
 * List Users in a Group
 * API returns the list of Users in the given groupId. Only Active and Pending users will be displayed. Removed users will not be listed.
 */
export const listUsersinaGroup = (options: Options<ListUsersinaGroupData>) => {
  return (options?.client ?? client).get<
    ListUsersinaGroupResponse,
    ListUsersinaGroupError
  >({
    ...options,
    url: '/groups/{groupId}/users',
  });
};

/**
 * Add users to group
 * Use this API to add users to an existing group
 */
export const adduserstogroup = (options: Options<AdduserstogroupData>) => {
  return (options?.client ?? client).post<
    AdduserstogroupResponse,
    AdduserstogroupError
  >({
    ...options,
    url: '/groups/{groupId}/users',
  });
};

/**
 * Delete users from group
 * Use this API to remove users from an existing group <br/>
 * [<br/>
 * {<br/>
 * "id": "Dyfw481f299"<br/>
 * },<br/>
 * {<br/>
 * "id": "T2P8S-tqF7s"<br/>
 * }<br/>
 * ]
 */
export const deleteusersfromgroup = (
  options: Options<DeleteusersfromgroupData>
) => {
  return (options?.client ?? client).delete<
    DeleteusersfromgroupResponse,
    DeleteusersfromgroupError
  >({
    ...options,
    url: '/groups/{groupId}/users',
  });
};

/**
 * List linked entities for objects
 * This API returns the list of links based on the version Id of the 3d model and the object Id (or object source Id).
 */
export const listlinkedentitiesforobjects = (
  options?: Options<ListlinkedentitiesforobjectsData>
) => {
  return (options?.client ?? client).get<
    ListlinkedentitiesforobjectsResponse,
    ListlinkedentitiesforobjectsError
  >({
    ...options,
    url: '/objectlink',
  });
};

/**
 * Create object link
 * This API creates a single object link. New Target TOPIC is added which accepts Topic uuid as Id
 */
export const createobjectlink = (options: Options<CreateobjectlinkData>) => {
  return (options?.client ?? client).post<
    CreateobjectlinkResponse,
    CreateobjectlinkError
  >({
    ...options,
    url: '/objectlink',
  });
};

/**
 * Bulk create object links
 * This api bulk creates a collection of object links. New Target TOPIC is added which accepts Topic uuid as Id
 */
export const bulkcreateobjectlinks = (
  options: Options<BulkcreateobjectlinksData>
) => {
  return (options?.client ?? client).post<
    BulkcreateobjectlinksResponse,
    BulkcreateobjectlinksError
  >({
    ...options,
    url: '/objectlink/objectlinks',
  });
};

/**
 * List links for the given target entity
 * This API returns the set of object links for a given target. For versioned target, either id or versionId must be provided.
 */
export const listlinksforthegiventargetentity = (
  options: Options<ListlinksforthegiventargetentityData>
) => {
  return (options?.client ?? client).get<
    ListlinksforthegiventargetentityResponse,
    ListlinksforthegiventargetentityError
  >({
    ...options,
    url: '/objectlink/target',
  });
};

/**
 * Delete an object link
 * Delete an object link
 */
export const deleteaobjectlink = (options: Options<DeleteaobjectlinkData>) => {
  return (options?.client ?? client).delete<
    DeleteaobjectlinkResponse,
    DeleteaobjectlinkError
  >({
    ...options,
    url: '/objectlink/{linkId}',
  });
};

/**
 * Update object links
 * Update object links
 */
export const updateobjectlinks = (options: Options<UpdateobjectlinksData>) => {
  return (options?.client ?? client).patch<
    UpdateobjectlinksResponse,
    UpdateobjectlinksError
  >({
    ...options,
    url: '/objectlink/{linkId}',
  });
};

/**
 * List all Projects
 * API to list all the projects for the user. Folders count metric includes the root folder as well.
 */
export const listallProjects = (options?: Options<ListallProjectsData>) => {
  return (options?.client ?? client).get<
    ListallProjectsResponse,
    ListallProjectsError
  >({
    ...options,
    url: '/projects',
  });
};

/**
 * Create a New Project
 * You may create a new Project using this action.
 *
 * TC supports max length of 255 characters for project names. Names are validated according to OS supported rules, so ones that contain non-printable ascii or with special meaning will be rejected by the API (Ex: "..", "PRN", "/")
 */
export const createaNewProject = (options: Options<CreateaNewProjectData>) => {
  return (options?.client ?? client).post<
    CreateaNewProjectResponse,
    CreateaNewProjectError
  >({
    ...options,
    url: '/projects',
  });
};

/**
 * Request access to projects the user is not part of.
 * This API allows users to request access to project they are not currently part of by triggering an email to project admins.
 */
export const requestProjectAccess = (
  options: Options<RequestProjectAccessData>
) => {
  return (options?.client ?? client).post<
    RequestProjectAccessResponse,
    RequestProjectAccessError
  >({
    ...options,
    url: '/projects/accessRequests',
  });
};

/**
 * Clone project from existing project
 * This API facilitates the creation of a new project by cloning an existing one.
 * API supports cloning settings, users, groups, folders and permissions of an
 * existing project. It generates a request to clone the given project and returns
 * the details of the clone process. Status of the clone process can be tracked
 * using the GET project clone details API.
 *
 *
 * The 'include' field in the request body indicate the items to be included in
 * clone. The selection of these items could be done in any manner. Only those
 * items that are selected will be included in clone.
 *
 *
 * However, there is also a special scenario
 *
 *
 * `*` => implicitly includes all options (folders, users, groups, settings and folderPermissions)
 *
 *
 * Examples on how different values in 'include' control the clone behavior
 *
 *
 * - folders + users => folders and users alone will be cloned
 *
 * - folders + groups => folders and groups alone will be cloned
 *
 * - folders + users + settings => folders, users and settings alone will be cloned
 *
 * - folders + folderPermissions => folders and default folder permissions will be cloned
 *
 * - folders + users + folderPermissions => folders, users, default folder permissions and user permissions in folder level will be cloned
 *
 * - folders + groups + folderPermissions => folders, groups, default default permissions and group permissions in folder level will be cloned.
 *
 * - folders + folderPermissions + settings => folders, folder default permissions and settings will be cloned
 *
 * - `*` => all items (folders, users, groups, respective folder permissions and settings) will be cloned
 *
 * - settings + users + groups + folderPermissions =>   settings, users and groups will be cloned
 *
 * `Permission level required:` Only project admins can perform the project clone operation
 */
export const cloneProject = (options: Options<CloneProjectData>) => {
  return (options?.client ?? client).post<
    CloneProjectResponse,
    CloneProjectError
  >({
    ...options,
    url: '/projects/clones',
  });
};

/**
 * Get the details of project clone
 * API to fetch details of the project clone. The response will contain the id of the cloned project (inside the `result` object) in case of successful clone, or will contain information about the reason for failure in case of clone failure.
 *
 * `Permission level required:` This API can be accessed only by the user who initiated the project clone
 */
export const getProjectCloneDetails = (
  options: Options<GetProjectCloneDetailsData>
) => {
  return (options?.client ?? client).get<
    GetProjectCloneDetailsResponse,
    GetProjectCloneDetailsError
  >({
    ...options,
    url: '/projects/clones/{cloneId}',
  });
};

/**
 * List all projects with minimal information
 * This API is used to fetch the project details of logged-in user which contains following details:projectId, role of logged-in user in the project and the list of group identifiers. Can be used as an efficient way to fetch a list of projects user is member of for making e.g. autorization decision.
 */
export const listAllProjectsMini = (options?: Options) => {
  return (options?.client ?? client).get<
    ListAllProjectsMiniResponse,
    ListAllProjectsMiniError
  >({
    ...options,
    url: '/projects/me',
  });
};

/**
 * Get Project Details
 * API to fetch details of a project.Folders count metric includes the root folder as well.
 *
 * Note : An empty object for "license" property indicates that the project does not have any license mapped with it in ECom Enforcement rules.
 */
export const getProjectDetails = (options: Options<GetProjectDetailsData>) => {
  return (options?.client ?? client).get<
    GetProjectDetailsResponse,
    GetProjectDetailsError
  >({
    ...options,
    url: '/projects/{projectId}',
  });
};

/**
 * Delete Project
 * API to delete a project
 */
export const deleteProject = (options: Options<DeleteProjectData>) => {
  return (options?.client ?? client).delete<
    DeleteProjectResponse,
    DeleteProjectError
  >({
    ...options,
    url: '/projects/{projectId}',
  });
};

/**
 * Update Project
 * The following properties can be updated using this request (any field can be updated individually)
 * * name
 * * address
 * * description
 * * startDate
 * * endDate
 * * lastVisitedOn
 * * crs
 *
 * *The date can be reset to NULL if you pass empty string as input for startDate and endDate*
 *
 * **Note :** For startDate and endDate, only the date will be considered from the timestamp, not the time or timezone.
 */
export const updateProject = (options: Options<UpdateProjectData>) => {
  return (options?.client ?? client).patch<
    UpdateProjectResponse,
    UpdateProjectError
  >({
    ...options,
    url: '/projects/{projectId}',
  });
};

/**
 * Upload Project Image
 * API to set an image for the project <br> Supported types are **jpg,jpeg,gif,png,tif,tiff,bmp**
 */
export const uploadProjectImage = (
  options: Options<UploadProjectImageData>
) => {
  return (options?.client ?? client).post<
    UploadProjectImageResponse,
    UploadProjectImageError
  >({
    ...options,
    ...formDataBodySerializer,
    url: '/projects/{projectId}/image',
  });
};

/**
 * Get Project license details
 * API to get license details for a project.
 */
export const getProjectlicensedetails = (
  options: Options<GetProjectlicensedetailsData>
) => {
  return (options?.client ?? client).get<
    GetProjectlicensedetailsResponse,
    GetProjectlicensedetailsError
  >({
    ...options,
    url: '/projects/{projectId}/license',
  });
};

/**
 * Update Project license
 * API to update the license assigned to a project by license id. This API is accessible for all the project admins to update the project's license using one of their active licenses. Additionally, site admins can utilize this API to update a project's license on behalf of a user, using any active license assigned to that user by passing subscriptionId in the request body.
 */
export const updateProjectLicenseDetails = (
  options: Options<UpdateProjectLicenseDetailsData>
) => {
  return (options?.client ?? client).patch<
    UpdateProjectLicenseDetailsResponse,
    UpdateProjectLicenseDetailsError
  >({
    ...options,
    url: '/projects/{projectId}/license',
  });
};

/**
 * Get Project Metrics
 * API to fetch metrics of a project. Folders count metric includes the root folder as well.
 */
export const getProjectMetrics = (options: Options<GetProjectMetricsData>) => {
  return (options?.client ?? client).get<
    GetProjectMetricsResponse,
    GetProjectMetricsError
  >({
    ...options,
    url: '/projects/{projectId}/metrics',
  });
};

/**
 * Get project content changes since last time
 * Fetch the changes in the project content happend after the sync cursor value proved in the `status` parameter.
 * The API allows to fetch changes in project files and folders. Each change represents a new version of the file or folder. Changes are ordered by the time. The API can be thought of as a stream of change events, client fetches events from the stream using a cursor (skipToken) that represents a position in the stream. If skipToken is not provided then events are fetched from the beginning of the project history, otherwise only events that happen after the given cursor are returned. The API allows to implement efficient incremental synchronisation (or cache invalidation) for the project file system on the client side.
 */
export const getProjectSyncObjects = (
  options: Options<GetProjectSyncObjectsData>
) => {
  return (options?.client ?? client).get<
    GetProjectSyncObjectsResponse,
    GetProjectSyncObjectsError
  >({
    ...options,
    url: '/projects/{projectId}/objects',
  });
};

/**
 * List roles available in project
 * API to list the roles available in a project.
 */
export const listrolesavailableinproject = (
  options: Options<ListrolesavailableinprojectData>
) => {
  return (options?.client ?? client).get<
    ListrolesavailableinprojectResponse,
    ListrolesavailableinprojectError
  >({
    ...options,
    url: '/projects/{projectId}/roles',
  });
};

/**
 * Get Project settings
 * API to List all the project specific settings.
 */
export const getProjectsettings = (
  options: Options<GetProjectsettingsData>
) => {
  return (options?.client ?? client).get<
    GetProjectsettingsResponse,
    GetProjectsettingsError
  >({
    ...options,
    url: '/projects/{projectId}/settings',
  });
};

/**
 * Update Project Settings
 * This API will set all settings related to project. Generally sets sync,notifications,unit settings. "ALLOW_AUTO_CHECKOUT" is the default value in case if sync mode is not given in sync settings.
 *
 * **Unit Settings :**
 * API allows to reset all the values to metric/imperial/USSurveyFeet if unitsystem is the only attribute in the api Request. Custom unit system allows setting mix and match values.
 *
 * eg: "unitSettings": {
 * "unitsystem": "metric”
 * }
 *
 * **Acceptable values for unitsettings :**
 *
 * <p>Decimal precisions - (0, 0.1, 0.01, 0.001, 0.0001, 0.00001, 0.000001, 0.0000001, 0.00000001)<br>
 * Fractional precisions -(1/2,1/4,1/8,1/16,1/32,1/64)<br></p>
 *
 * unitsystem - (metric, imperial, USSurveyFeet, custom)
 * <p align="right"><i>Defaults are in bold</i></p>
 * <table>
 * <tr>
 * <td></td>
 * <th>metric</th>
 * <th>imperial</th>
 * <th>USSurveyFeet</th>
 * </tr>
 * <tr>
 * <td>lengthunit</td>
 * <td><b>mm</b> - <b>0</b>
 * <br/>cm - <b>0.1</b>
 * <br/>m - <b>0.01</b>
 * <br/>km  - <b>0.001</b></td>
 * <td><b>in</b> - <b>0.1</b>
 * <br/>ft-in - <b>1/4</b>
 * <br/>ft - <b>0.01</b>
 * <br/>yd - <b>0.01</b>
 * <br/>mi - <b>0.001</b>
 * <br/>usft - <b>0.001</b></td>
 * <td>sIN - <b>0.1</b>
 * <br/><b>sFT</b> - <b>0.01</b>
 * <br/>sYD - <b>0.01</b>
 * <br/>sMI - <b>0.001</b></td>
 * </tr>
 * <tr>
 * <td>lengthmeasurementunit</td>
 * <td><b>mm</b> - <b>0</b>
 * <br/>cm - <b>0.1</b>
 * <br/>m - <b>0.01</b>
 * <br/>km - <b>0.001</b></td>
 * <td><b>in</b> - <b>0.1</b>
 * <br/>ft-in - <b>1/4</b>
 * <br/>ft - <b>0.01</b>
 * <br/>yd - <b>0.01</b>
 * <br/>mi - <b>0.001</b></td>
 * <td>sIN - <b>0.1</b>
 * <br/><b>sFT</b> - <b>0.01</b>
 * <br/>sYD - <b>0.01</b>
 * <br/>sMI - <b>0.001</b></td>
 * </tr>
 * <tr>
 * <td>areaunit</td>
 * <td>mm2 - <b>0</b>
 * <br/>cm2 - <b>0.1</b>
 * <br/><b>m2</b> - <b>0.01</b>
 * <br/>ha - <b>0.001</b></td>
 * <td>in2 - <b>0.1</b>
 * <br/><b>ft2</b> - <b>0.01</b>
 * <br/>yd2 - <b>0.001</b>
 * <br/>ac - <b>0.001</b>
 * <br/>mi2 - <b>0.001</b>
 * <br/>usft2 - <b>0.001</b>
 * <br/>usyd2 - <b>0.001</b></td>
 * <td>in2 - <b>0.1</b>
 * <br/><b>ft2</b> - <b>0.01</b>
 * <br/>yd2 - <b>0.001</b></td>
 * </tr>
 * <tr>
 * <td>volumeunit</td>
 * <td>mm3 - <b>0</b>
 * <br/>cm3 - <b>0.1</b>
 * <br/><b>m3</b> - <b>0.01</b></td>
 * <td>in3 - <b>0.1</b>
 * <br/>ft3 - <b>0.01</b>
 * <br/><b>yd3</b> - <b>0.001</b>
 * <br/>usft3 - <b>0.001</b>
 * <br/>usyd3 - <b>0.001</b>
 * <br/>acft - <b>0.001</b>
 * <br/>usacft - <b>0.001</b></td>
 * <td>in3 - <b>0.1</b>
 * <br/>ft3 - <b>0.01</b>
 * <br/><b>yd3</b> - <b>0.001</b></td>
 * </tr>
 * <tr>
 * <td>weightunit</td>
 * <td>mg - <b>0</b>
 * <br/>g - <b>0.1</b>
 * <br/>kg - <b>0.01</b>
 * <br/><b>t</b> - <b>0.001</b></td>
 * <td>oz - <b>0.1</b>
 * <br/>lb - <b>0.01</b>
 * <br/><b>ton</b> - <b>0.001</b>
 * <br/>stone - <b>0.001</b></td>
 * <td>oz - <b>0.1</b>
 * <br/>lb - <b>0.01</b>
 * <br/><b>ton</b> - <b>0.001</b></td>
 * </tr>
 * <tr>
 * <td>angularunit</td>
 * <td><b>deg</b> - <b>0.001</b>
 * <br/>rad - <b>0.01</b>
 * <br/>deg-min-sec - <b>0.001</b></td>
 * <td><b>deg</b> - <b>0.001</b>
 * <br/>rad - <b>0.01</b>
 * <br/>deg-min-sec - <b>0.001</b></td>
 * <td><b>deg</b> - <b>0.001</b>
 * <br/>rad - <b>0.01</b>
 * <br/>deg-min-sec - <b>0.001</b></td>
 * </tr>
 * </table>
 */
export const updateProjectSettings = (
  options: Options<UpdateProjectSettingsData>
) => {
  return (options?.client ?? client).patch<
    UpdateProjectSettingsResponse,
    UpdateProjectSettingsError
  >({
    ...options,
    url: '/projects/{projectId}/settings',
  });
};

/**
 * Get project content sync cursor.
 * Returns the project content sync cursor. This sync cursor is exected to be used together with the `ObjectSync` API to detect changes in the project content and do the incremental sync.
 */
export const getProjectSyncStatus = (
  options: Options<GetProjectSyncStatusData>
) => {
  return (options?.client ?? client).get<
    GetProjectSyncStatusResponse,
    GetProjectSyncStatusError
  >({
    ...options,
    url: '/projects/{projectId}/status',
  });
};

/**
 * List all Users in project
 * API to fetch list of users in a project
 */
export const listallUsersinproject = (
  options: Options<ListallUsersinprojectData>
) => {
  return (options?.client ?? client).get<
    ListallUsersinprojectResponse,
    ListallUsersinprojectError
  >({
    ...options,
    url: '/projects/{projectId}/users',
  });
};

/**
 * Add/Invite Users to project
 *  This API allows you to invite new and existing users to a project.
 *
 * Email address and role are required to add users to project.
 *
 * The Response will be minimal for user not in Trimble Connect and for the users in the Trimble Connect there will be complete Response.
 *
 * In mininal Response there will be only three fields in the Response body **Email** , **status** , **role**
 */
export const addInviteUserstoproject = (
  options: Options<AddInviteUserstoprojectData>
) => {
  return (options?.client ?? client).post<
    AddInviteUserstoprojectResponse,
    AddInviteUserstoprojectError
  >({
    ...options,
    url: '/projects/{projectId}/users',
  });
};

/**
 * Get User Details
 * API to get user details by project Id and  Trimble Connect user identifier(userId). Use `me` alias (`/projects/{projectId}/users/me`) to get details about the user associated with the passed access token.
 */
export const getProjectUserDetails = (
  options: Options<GetProjectUserDetailsData>
) => {
  return (options?.client ?? client).get<
    GetProjectUserDetailsResponse,
    GetProjectUserDetailsError
  >({
    ...options,
    url: '/projects/{projectId}/users/{userId}',
  });
};

/**
 * Remove user
 * API to remove a particular user from the project
 */
export const removeuser = (options: Options<RemoveuserData>) => {
  return (options?.client ?? client).delete<
    RemoveuserResponse,
    RemoveuserError
  >({
    ...options,
    url: '/projects/{projectId}/users/{userId}',
  });
};

/**
 * Update User role
 * API to update the role of user in a project
 */
export const updateUserrole = (options: Options<UpdateUserroleData>) => {
  return (options?.client ?? client).patch<
    UpdateUserroleResponse,
    UpdateUserroleError
  >({
    ...options,
    url: '/projects/{projectId}/users/{userId}',
  });
};

/**
 * Get Available Regions
 * Get Available Regions
 */
export const getAvailableRegions = (options?: Options) => {
  return (options?.client ?? client).get<
    GetAvailableRegionsResponse2,
    GetAvailableRegionsError
  >({
    ...options,
    url: '/regions',
  });
};

/**
 * List all Releases
 * This API will fetch all the releases for the project. To fetch specific release status the optional __status__ query parameter can be used.
 */
export const listallReleases = (options: Options<ListallReleasesData>) => {
  return (options?.client ?? client).get<
    ListallReleasesResponse,
    ListallReleasesError
  >({
    ...options,
    url: '/releases',
  });
};

/**
 * Create a New Release
 * API to create a new Release.
 *
 * + name (string) - Name of the release
 *
 * + dueDate (timestamp) - Due date for the release
 *
 * + projectId (string) - Project Identifier
 *
 * Following fields can be optionally specified while creating the release:
 *
 * + notes (string) - notes for the release
 *
 * + recipients (array of users/groups) - recipients of the release
 */
export const createaNewRelease = (options: Options<CreateaNewReleaseData>) => {
  return (options?.client ?? client).post<
    CreateaNewReleaseResponse,
    CreateaNewReleaseError
  >({
    ...options,
    url: '/releases',
  });
};

/**
 * Download files in release
 * You can download the file versions associated to a release. List of versionIds should be passed in the Request. If multiple file versions passed in the Request body, the output will be zip file format. If no versions passed in the Request body (i.e empty array),  all file versions associated to the release will be downloaded
 */
export const downloadfilesinrelease = (
  options: Options<DownloadfilesinreleaseData>
) => {
  return (options?.client ?? client).post<
    DownloadfilesinreleaseResponse,
    DownloadfilesinreleaseError
  >({
    ...options,
    url: '/releases/downloadFiles',
  });
};

/**
 * Get Release Details
 * Get Release Details
 */
export const getReleaseDetails = (options: Options<GetReleaseDetailsData>) => {
  return (options?.client ?? client).get<
    GetReleaseDetailsResponse,
    GetReleaseDetailsError
  >({
    ...options,
    url: '/releases/{releaseId}',
  });
};

/**
 * Delete Release
 * API to delete a release
 */
export const deleteRelease = (options: Options<DeleteReleaseData>) => {
  return (options?.client ?? client).delete<
    DeleteReleaseResponse,
    DeleteReleaseError
  >({
    ...options,
    url: '/releases/{releaseId}',
  });
};

/**
 * Edit Release
 * This API allows you to update the following properties of the Release:
 *
 * - name
 *
 * - dueDate
 *
 * - notes
 *
 * - recipients
 *
 * - status
 *
 * To send the release to recipients, the __status__ property has to be set as "SENT" in the Request body.
 */
export const editRelease = (options: Options<EditReleaseData>) => {
  return (options?.client ?? client).patch<
    EditReleaseResponse,
    EditReleaseError
  >({
    ...options,
    url: '/releases/{releaseId}',
  });
};

/**
 * List all files
 * This API returns a list of files for the Release
 */
export const listallfiles = (options: Options<ListallfilesData>) => {
  return (options?.client ?? client).get<
    ListallfilesResponse,
    ListallfilesError
  >({
    ...options,
    url: '/releases/{releaseId}/files',
  });
};

/**
 * Add files
 * You can add files using this API to Release.
 */
export const addfiles = (options: Options<AddfilesData>) => {
  return (options?.client ?? client).post<AddfilesResponse, AddfilesError>({
    ...options,
    url: '/releases/{releaseId}/files',
  });
};

/**
 * Remove files
 * You can remove files from release using this API. This api takes below json as request body <br/>
 * [<br/>
 * {<br/>
 * "id": "woC32em2Fb0",<br/>
 * "type": "FILE"<br/>
 * }<br/>
 * ]<br/>
 */
export const removefiles = (options: Options<RemovefilesData>) => {
  return (options?.client ?? client).delete<
    RemovefilesResponse,
    RemovefilesError
  >({
    ...options,
    url: '/releases/{releaseId}/files',
  });
};

/**
 * List All Search Results
 * List All Search Results
 */
export const listAllSearchResults = (
  options: Options<ListAllSearchResultsData>
) => {
  return (options?.client ?? client).get<
    ListAllSearchResultsResponse2,
    ListAllSearchResultsError
  >({
    ...options,
    url: '/search',
  });
};

/**
 * List all Shares
 * This API will fetch all the shares by the user.
 *
 * If the calling user is the project admin, then the Response will have all shares for the  given projectId, else it will return the shares created by that user in project.
 *
 * If the projectId is not given, then the API Response will have shares across all the projects for the calling user.
 *
 * The default limit will be 25 elemenets, maximum of 1000 elements can be fetched on ranged Request
 */
export const listallShares = (options?: Options<ListallSharesData>) => {
  return (options?.client ?? client).get<
    ListallSharesResponse,
    ListallSharesError
  >({
    ...options,
    url: '/shares',
  });
};

/**
 * Create a New Share
 * You may create a new Share using this action.
 *
 * Depending on mode, for "PROJECT_USERS", valid values for "notify" object's "type" field are ['USER', 'GROUP'], and for other two modes, valid type is "EMAIL" (with "id" being the actual email address)
 *
 * For Objects array, in case of FILE object type, user can specify optional "useLatestVersion" boolean field. Defaults to "true".
 *
 * For "PROJECT_USERS" mode, "expiryDate", "permission", and "useLatestVersion" are defaulted and cannot be specified in the API.
 *
 * - expiryDate : never
 *
 * - permission : DOWNLOAD
 *
 * - useLatestVersion : TRUE
 */
export const createaNewShare = (options: Options<CreateaNewShareData>) => {
  return (options?.client ?? client).post<
    CreateaNewShareResponse,
    CreateaNewShareError
  >({
    ...options,
    url: '/shares',
  });
};

/**
 * Get Share Details along with public accesstoken.
 * Get details of the particular share using share token along with accessToken to access the files shared in public mode
 */
export const getShareDetailsWithAccessTokenUsingStoken = (
  options: Options<GetShareDetailsWithAccessTokenUsingStokenData>
) => {
  return (options?.client ?? client).get<
    GetShareDetailsWithAccessTokenUsingStokenResponse,
    GetShareDetailsWithAccessTokenUsingStokenError
  >({
    ...options,
    url: '/shares/token/{stoken}',
  });
};

/**
 * Get Share Details
 * Get Share Details
 */
export const getShareDetails = (options: Options<GetShareDetailsData>) => {
  return (options?.client ?? client).get<
    GetShareDetailsResponse,
    GetShareDetailsError
  >({
    ...options,
    url: '/shares/{shareId}',
  });
};

/**
 * Delete Share
 * This API will allow you to revoke the share. Shared URLs will be invalidated.
 */
export const deleteShare = (options: Options<DeleteShareData>) => {
  return (options?.client ?? client).delete<
    DeleteShareResponse,
    DeleteShareError
  >({
    ...options,
    url: '/shares/{shareId}',
  });
};

/**
 * Edit Share
 * Depending on mode, for "PROJECT_USERS", valid values for "notify" object's "type" field are ['USER', 'GROUP'], and for other two modes, valid type is "EMAIL" (with "id" being the actual email address)
 *
 * For Objects array, in case of FILE object type, user can specify optional "useLatestVersion" boolean field. Defaults to "true".
 *
 * For "PROJECT_USERS" mode, "expiryDate", "permission", and "useLatestVersion" are defaulted and cannot be specified in the API. The defaults are:
 *
 * - expiryDate : never
 *
 * - permission : DOWNLOAD
 *
 * - useLatestVersion : TRUE
 *
 * This API allows you to update the following properties of the Share:
 *
 * - mode (optional, string, `PUBLIC`) ... Sharing mode [Valid values : 'PROJECT_USERS', 'REGISTERED_USERS', 'PUBLIC']
 *
 * - expiryDate (optional, timestamp, `2017-01-26T16:33:49-0800`) ... Expiry date for the Shared link
 *
 * - permission (optional, string, `VIEW`) ... Sharing permission [Valid values are 'VIEW', 'DOWNLOAD']
 *
 * - notify (optional, array of objects, `[{ "id" : "7zpaQqEEiR8", "type" : "USER" }]`) ... Users/Groups to share with [Valid values : 'USER', 'GROUP', 'EMAIL']
 *
 * - message (optional, string, `sample note`) ... Message to be sent as part of email notification (Limit - 1024 characters)
 *
 * - objects (optional, array of objects, `[{ "id" : "CXSNUuANPZA", "type" : "FILE", "useLatestVersion" : "true" }]`) ... Objects to Share, with fields "id" and "type" [Valid values : 'FILE']
 *
 * Refer to object representation for details on these fields
 */
export const editShare = (options: Options<EditShareData>) => {
  return (options?.client ?? client).patch<EditShareResponse, EditShareError>({
    ...options,
    url: '/shares/{shareId}',
  });
};

/**
 * List Tags in a project
 * API to list Tags under a project / mapped with an object
 */
export const listTagsinaproject = (
  options?: Options<ListTagsinaprojectData>
) => {
  return (options?.client ?? client).get<
    ListTagsinaprojectResponse,
    ListTagsinaprojectError
  >({
    ...options,
    url: '/tags',
  });
};

/**
 * Create Tag
 * API to create a Tag under a project
 */
export const createTag = (options: Options<CreateTagData>) => {
  return (options?.client ?? client).post<CreateTagResponse, CreateTagError>({
    ...options,
    url: '/tags',
  });
};

/**
 * Get Tag Details
 * API to fetch details of a tag
 */
export const getTagDetails = (options: Options<GetTagDetailsData>) => {
  return (options?.client ?? client).get<
    GetTagDetailsResponse,
    GetTagDetailsError
  >({
    ...options,
    url: '/tags/{tagId}',
  });
};

/**
 * Delete Tag
 * API to delete a tag
 */
export const deleteTag = (options: Options<DeleteTagData>) => {
  return (options?.client ?? client).delete<DeleteTagResponse, DeleteTagError>({
    ...options,
    url: '/tags/{tagId}',
  });
};

/**
 * Edit Tag
 * API to update the Tag properties
 */
export const editTag = (options: Options<EditTagData>) => {
  return (options?.client ?? client).patch<EditTagResponse, EditTagError>({
    ...options,
    url: '/tags/{tagId}',
  });
};

/**
 * List objects in a Tag
 * API to list objects mapped to a tag
 */
export const listobjectsinaTag = (options: Options<ListobjectsinaTagData>) => {
  return (options?.client ?? client).get<
    ListobjectsinaTagResponse,
    ListobjectsinaTagError
  >({
    ...options,
    url: '/tags/{tagId}/objects',
  });
};

/**
 * Add objects to Tag
 * API to map objects to a tag
 */
export const addobjectstoTag = (options: Options<AddobjectstoTagData>) => {
  return (options?.client ?? client).post<
    AddobjectstoTagResponse,
    AddobjectstoTagError
  >({
    ...options,
    url: '/tags/{tagId}/objects',
  });
};

/**
 * Remove objects from Tag
 * API to remove objects from a tag
 * This API takes below request body <br/>
 * [<br/>
 * {<br/>
 * "id": "woC32em2Fb0",<br/>
 * "objectType": "FILE"<br/>
 * }<br/>
 * ]
 */
export const removeobjectsfromTag = (
  options: Options<RemoveobjectsfromTagData>
) => {
  return (options?.client ?? client).delete<
    RemoveobjectsfromTagResponse,
    RemoveobjectsfromTagError
  >({
    ...options,
    url: '/tags/{tagId}/objects',
  });
};

/**
 * List all ToDos
 * This API returns the list of todos in a project based on either project Id or file
 * Id using which todos are created.
 */
export const listallToDos = (options: Options<ListallToDosData>) => {
  return (options?.client ?? client).get<
    ListallToDosResponse,
    ListallToDosError
  >({
    ...options,
    url: '/todos',
  });
};

/**
 * Create a New ToDo
 * You may create a new ToDo using this action.
 *
 * + description (string) - The details of the ToDo
 *
 * + projectId (string) - Project Identifier
 *
 * Optional parameters you can define on creation:
 *
 * - type (follow  BCF 2.0 spec)
 *
 * - title
 *
 * - label
 *
 * - dueDate
 *
 * - percentComplete
 *
 * - status
 *
 * - priority
 *
 * - assignees
 */
export const createaNewToDo = (options: Options<CreateaNewToDoData>) => {
  return (options?.client ?? client).post<
    CreateaNewToDoResponse,
    CreateaNewToDoError
  >({
    ...options,
    url: '/todos',
  });
};

/**
 * List all Todo Types of a Project
 * List all Todo Types of a Project
 */
export const listallTodoTypesofaProject = (
  options: Options<ListallTodoTypesofaProjectData>
) => {
  return (options?.client ?? client).get<
    ListallTodoTypesofaProjectResponse,
    ListallTodoTypesofaProjectError
  >({
    ...options,
    url: '/todos/types',
  });
};

/**
 * Get ToDo Details
 * Get ToDo Details
 */
export const getToDoDetails = (options: Options<GetToDoDetailsData>) => {
  return (options?.client ?? client).get<
    GetToDoDetailsResponse,
    GetToDoDetailsError
  >({
    ...options,
    url: '/todos/{todoId}',
  });
};

/**
 * Delete a ToDo
 * Delete a ToDo
 */
export const deleteToDo = (options: Options<DeleteToDoData>) => {
  return (options?.client ?? client).delete<
    DeleteToDoResponse,
    DeleteToDoError
  >({
    ...options,
    url: '/todos/{todoId}',
  });
};

/**
 * Update ToDo
 * This API allows you to update the following properties of the ToDo:
 *
 * Note : Custom ToDo Label would not be updated from here.
 *
 * - type
 *
 * - title
 *
 * - label
 *
 * - description
 *
 * - dueDate
 *
 * - percentComplete
 *
 * - status
 *
 * - priority
 *
 * - assignees
 */
export const updateToDo = (options: Options<UpdateToDoData>) => {
  return (options?.client ?? client).patch<UpdateToDoResponse, UpdateToDoError>(
    {
      ...options,
      url: '/todos/{todoId}',
    }
  );
};

/**
 * List all attachments
 * These sets of APIs allow you to list attachments to a ToDo.
 */
export const listallattachments = (
  options: Options<ListallattachmentsData>
) => {
  return (options?.client ?? client).get<
    ListallattachmentsResponse,
    ListallattachmentsError
  >({
    ...options,
    url: '/todos/{todoId}/attachments',
  });
};

/**
 * Add attachments
 * These sets of APIs allow you to add attachments to a ToDo.
 */
export const addattachments = (options: Options<AddattachmentsData>) => {
  return (options?.client ?? client).post<
    AddattachmentsResponse,
    AddattachmentsError
  >({
    ...options,
    url: '/todos/{todoId}/attachments',
  });
};

/**
 * Remove attachments
 * These sets of APIs allow you to remove attachments to a ToDo.
 */
export const removeattachments = (options: Options<RemoveattachmentsData>) => {
  return (options?.client ?? client).delete<
    RemoveattachmentsResponse,
    RemoveattachmentsError
  >({
    ...options,
    url: '/todos/{todoId}/attachments',
  });
};

/**
 * List All Supported Languages
 * Response is an array of all available Languages supported by Trimble Connect.
 */
export const listAllSupportedLanguages = (options?: Options) => {
  return (options?.client ?? client).get<
    ListAllSupportedLanguagesResponse,
    ListAllSupportedLanguagesError
  >({
    ...options,
    url: '/users/languages',
  });
};

/**
 * List User Licenses
 * API to fetch licenses for a current user context
 *
 * An empty object for "license" property indicates that the user does not have any license mapped.
 */
export const listUserLicenses = (options?: Options) => {
  return (options?.client ?? client).get<
    ListUserLicensesResponse,
    ListUserLicensesError
  >({
    ...options,
    url: '/users/licenses',
  });
};

/**
 * List All Available Timezones
 * Response is an array of all available Timezones supported by Trimble Connect.
 */
export const listAllAvailableTimezones = (options?: Options) => {
  return (options?.client ?? client).get<
    ListAllAvailableTimezonesResponse,
    ListAllAvailableTimezonesError
  >({
    ...options,
    url: '/users/timezones',
  });
};

/**
 * Get User Details
 * Get user details by Trimble Connect user identifier. Use `me` alias (`/users/me`) to get details about the user associated with the passed access token.
 */
export const getUserDetails = (options: Options<GetUserDetailsData>) => {
  return (options?.client ?? client).get<
    GetUserDetailsResponse2,
    GetUserDetailsError
  >({
    ...options,
    url: '/users/{userId}',
  });
};

/**
 * Update User Details
 * This API allows you to update the following properties of the User Details:
 *
 * - timeZone
 *
 * - language
 *
 * - phone
 *
 * - podLocation
 *
 * - viewerBackground
 *
 * Supported values for language : [`en-us`,`da-dk`,`de-de`,`es-es`,`fi-fi`,`fr-fr`,`it-it`,`ja-jp`,`ko-kr`,`nb-bo`,`nl-nl`,`pt-br`,`ru-ru`,`sv-se`,`zh-hans`,`zh-hant`]
 */
export const updateUserDetails = (options: Options<UpdateUserDetailsData>) => {
  return (options?.client ?? client).patch<
    UpdateUserDetailsResponse,
    UpdateUserDetailsError
  >({
    ...options,
    url: '/users/{userId}',
  });
};

/**
 * List all View Groups
 * Get the list of all View Groups in a given project.
 */
export const listallViewGroups = (options: Options<ListallViewGroupsData>) => {
  return (options?.client ?? client).get<
    ListallViewGroupsResponse,
    ListallViewGroupsError
  >({
    ...options,
    url: '/viewgroups',
  });
};

/**
 * Create a View Group
 * Create a View Group
 */
export const createaViewGroup = (options: Options<CreateaViewGroupData>) => {
  return (options?.client ?? client).post<
    CreateaViewGroupResponse,
    CreateaViewGroupError
  >({
    ...options,
    url: '/viewgroups',
  });
};

/**
 * Get View Group Details
 * Get the details of a View Group.
 */
export const getViewGroupDetails = (
  options: Options<GetViewGroupDetailsData>
) => {
  return (options?.client ?? client).get<
    GetViewGroupDetailsResponse,
    GetViewGroupDetailsError
  >({
    ...options,
    url: '/viewgroups/{viewGroupId}',
  });
};

/**
 * Delete a View Group
 * You can use this API to delete a View Group.
 */
export const deleteViewGroup = (options: Options<DeleteViewGroupData>) => {
  return (options?.client ?? client).delete<
    DeleteViewGroupResponse,
    DeleteViewGroupError
  >({
    ...options,
    url: '/viewgroups/{viewGroupId}',
  });
};

/**
 * Update View Group Details
 * Update the name and views in the View Group. The views list provided in the PATCH Request is applied.
 */
export const updateViewGroupDetails = (
  options: Options<UpdateViewGroupDetailsData>
) => {
  return (options?.client ?? client).patch<
    UpdateViewGroupDetailsResponse,
    UpdateViewGroupDetailsError
  >({
    ...options,
    url: '/viewgroups/{viewGroupId}',
  });
};

/**
 * List all Views in a project
 * This API returns the list of views in a project based on either project Id or file Id using which views are created.
 */
export const listallViewsinaproject = (
  options: Options<ListallViewsinaprojectData>
) => {
  return (options?.client ?? client).get<
    ListallViewsinaprojectResponse,
    ListallViewsinaprojectError
  >({
    ...options,
    url: '/views',
  });
};

/**
 * Create View
 * API to create a view. Note that imageData has been truncated in the example below.
 * View can be created on a project level or as view embedded to ToDo. For creating embedded view an todoId property must be given in the Request with valid existing ToDo identifier.
 * **Note:** View models can span up to a limit of **`170`**.
 */
export const createView = (options: Options<CreateViewData>) => {
  return (options?.client ?? client).post<CreateViewResponse, CreateViewError>({
    ...options,
    url: '/views',
  });
};

/**
 * Create View with image
 * Create a view using form data. The form should have two fields; one named view which is the stringified view Json object, the other named imageData is the file to be used as thumbnail.
 *
 * **Note:** View models can span up to a limit of **`170`**.
 */
export const createViewWithThumbnail = (
  options?: Options<CreateViewWithThumbnailData>
) => {
  return (options?.client ?? client).post<
    CreateViewWithThumbnailResponse,
    CreateViewWithThumbnailError
  >({
    ...options,
    ...formDataBodySerializer,
    url: '/views/multiparts',
  });
};

/**
 * Update View with image
 * Update a view using form data. The form can have two fields; one named view which is the stringified view Json object, the other named imageData is the file to be used as thumbnail.
 * **Note:** View models can span up to a limit of **`170`**.
 */
export const updateViewWithThumbnail = (
  options: Options<UpdateViewWithThumbnailData>
) => {
  return (options?.client ?? client).patch<
    UpdateViewWithThumbnailResponse,
    UpdateViewWithThumbnailError
  >({
    ...options,
    ...formDataBodySerializer,
    url: '/views/multiparts/{viewId}',
  });
};

/**
 * Get View Details
 * Get View Details
 */
export const getViewDetails = (options: Options<GetViewDetailsData>) => {
  return (options?.client ?? client).get<
    GetViewDetailsResponse,
    GetViewDetailsError
  >({
    ...options,
    url: '/views/{viewId}',
  });
};

/**
 * Delete a View
 * Delete a View
 */
export const deleteView = (options: Options<DeleteViewData>) => {
  return (options?.client ?? client).delete<
    DeleteViewResponse,
    DeleteViewError
  >({
    ...options,
    url: '/views/{viewId}',
  });
};

/**
 * Update a View
 * Update a View
 */
export const updateView = (options: Options<UpdateViewData>) => {
  return (options?.client ?? client).patch<UpdateViewResponse, UpdateViewError>(
    {
      ...options,
      url: '/views/{viewId}',
    }
  );
};

/**
 * Get Camera Details
 * Get Camera Details
 */
export const getCameraDetails = (options: Options<GetCameraDetailsData>) => {
  return (options?.client ?? client).get<
    GetCameraDetailsResponse,
    GetCameraDetailsError
  >({
    ...options,
    url: '/views/{viewId}/camera',
  });
};

/**
 * Update Camera
 * Use this API to update a view's camera.  With the exception of the read-only fields: cameraId and viewId, all property could be updated.  For example, to update the up vector, just specify the necessary information the update:
 */
export const updateCamera = (options: Options<UpdateCameraData>) => {
  return (options?.client ?? client).patch<
    UpdateCameraResponse,
    UpdateCameraError
  >({
    ...options,
    url: '/views/{viewId}/camera',
  });
};

/**
 * Get snapshot image for a View
 * Returns the original size snapshot url as uploaded when view was created.
 */
export const getViewImage = (options: Options<GetViewImageData>) => {
  return (options?.client ?? client).get<
    GetViewImageResponse,
    GetViewImageError
  >({
    ...options,
    url: '/views/{viewId}/image',
  });
};

/**
 * Upload a Thumbnail Image for a View
 * Upload a Thumbnail Image for a View
 */
export const uploadViewThumbnailImage = (
  options: Options<UploadViewThumbnailImageData>
) => {
  return (options?.client ?? client).post<
    UploadViewThumbnailImageResponse2,
    UploadViewThumbnailImageError
  >({
    ...options,
    ...formDataBodySerializer,
    url: '/views/{viewId}/image',
  });
};

/**
 * List Markups
 * List Markups
 */
export const listMarkups = (options: Options<ListMarkupsData>) => {
  return (options?.client ?? client).get<ListMarkupsResponse, ListMarkupsError>(
    {
      ...options,
      url: '/views/{viewId}/markups',
    }
  );
};

/**
 * Create Markups
 * API to create markups.
 */
export const createMarkups = (options: Options<CreateMarkupsData>) => {
  return (options?.client ?? client).post<
    CreateMarkupsResponse,
    CreateMarkupsError
  >({
    ...options,
    url: '/views/{viewId}/markups',
  });
};

/**
 * Update a Markup
 * Update a Markup
 */
export const updateMarkup = (options: Options<UpdateMarkupData>) => {
  return (options?.client ?? client).patch<
    UpdateMarkupResponse,
    UpdateMarkupError
  >({
    ...options,
    url: '/views/{viewId}/markups',
  });
};

/**
 * Delete a Markup
 * Delete a Markup
 */
export const deleteMarkup = (options: Options<DeleteMarkupData>) => {
  return (options?.client ?? client).delete<
    DeleteMarkupResponse,
    DeleteMarkupError
  >({
    ...options,
    url: '/views/{viewId}/markups/{markupId}',
  });
};

/**
 * Get Presentation
 * Get Presentation
 */
export const getPresentation = (options: Options<GetPresentationData>) => {
  return (options?.client ?? client).get<
    GetPresentationResponse,
    GetPresentationError
  >({
    ...options,
    url: '/views/{viewId}/presentation',
  });
};

/**
 * Update a Presentation
 * Update a Presentation
 */
export const updatePresentation = (
  options: Options<UpdatePresentationData>
) => {
  return (options?.client ?? client).patch<
    UpdatePresentationResponse,
    UpdatePresentationError
  >({
    ...options,
    url: '/views/{viewId}/presentation',
  });
};

/**
 * List Section Planes
 * Use this API to get a view section plane.
 */
export const listSectionPlanes = (options: Options<ListSectionPlanesData>) => {
  return (options?.client ?? client).get<
    ListSectionPlanesResponse,
    ListSectionPlanesError
  >({
    ...options,
    url: '/views/{viewId}/sectionplanes',
  });
};

/**
 * Create Section Plane
 * Use this API to add a view section plane. To add a view section plane, supply the full object in the Request body.
 */
export const createSectionPlane = (
  options: Options<CreateSectionPlaneData>
) => {
  return (options?.client ?? client).post<
    CreateSectionPlaneResponse,
    CreateSectionPlaneError
  >({
    ...options,
    url: '/views/{viewId}/sectionplanes',
  });
};

/**
 * Update Section Plane
 * Use this API to update a view section plane.
 */
export const updateSectionPlane = (
  options: Options<UpdateSectionPlaneData>
) => {
  return (options?.client ?? client).patch<
    UpdateSectionPlaneResponse,
    UpdateSectionPlaneError
  >({
    ...options,
    url: '/views/{viewId}/sectionplanes',
  });
};

/**
 * Delete a Section Plane
 * Delete a Section Plane
 */
export const deleteSectionPlane = (
  options: Options<DeleteSectionPlaneData>
) => {
  return (options?.client ?? client).delete<
    DeleteSectionPlaneResponse,
    DeleteSectionPlaneError
  >({
    ...options,
    url: '/views/{viewId}/sectionplanes/{sectionplaneId}',
  });
};

/**
 * List all 2D Views
 * API to list 2D Views in a project based on either project Id or file Id using which views are created.
 */
export const listall2dViews = (options?: Options<Listall2dViewsData>) => {
  return (options?.client ?? client).get<
    Listall2dViewsResponse,
    Listall2dViewsError
  >({
    ...options,
    url: '/views2d',
  });
};

/**
 * Create a New 2D View
 * API to create a new 2D View. Thumbnail data can be attached as base64 encoded format in the Request.
 */
export const createaNew2dView = (options: Options<CreateaNew2dViewData>) => {
  return (options?.client ?? client).post<
    CreateaNew2dViewResponse,
    CreateaNew2dViewError
  >({
    ...options,
    url: '/views2d',
  });
};

/**
 * Create a new 2D View with image
 * Create a 2dview using Multipart/form-data media type. The form should have two fields; one named views2d which is the stringified 2dview Json object, the other named imageData is the file to be used as thumbnail.
 */
export const createa2dViewMultipart = (
  options: Options<Createa2dViewMultipartData>
) => {
  return (options?.client ?? client).post<
    Createa2dViewMultipartResponse,
    Createa2dViewMultipartError
  >({
    ...options,
    ...formDataBodySerializer,
    url: '/views2d/multiparts',
  });
};

/**
 * Update a 2D View with image
 * Update a 2dview using Multipart/form-data media type. The form can have two fields; one named view which is the stringified view Json object, the other named imageData is the file to be used as thumbnail.
 */
export const update2dViewMultipart = (
  options: Options<Update2dViewMultipartData>
) => {
  return (options?.client ?? client).patch<
    Update2dViewMultipartResponse,
    Update2dViewMultipartError
  >({
    ...options,
    ...formDataBodySerializer,
    url: '/views2d/multiparts/{viewId}',
  });
};

/**
 * Get 2D View details
 * API to get details of a 2D View by it's Id.
 */
export const get2dViewdetails = (options: Options<Get2dViewdetailsData>) => {
  return (options?.client ?? client).get<
    Get2dViewdetailsResponse,
    Get2dViewdetailsError
  >({
    ...options,
    url: '/views2d/{viewId}',
  });
};

/**
 * Delete 2D View
 * API to delete 2D View by it's id.
 */
export const delete2dView = (options: Options<Delete2dViewData>) => {
  return (options?.client ?? client).delete<
    Delete2dViewResponse,
    Delete2dViewError
  >({
    ...options,
    url: '/views2d/{viewId}',
  });
};

/**
 * Update 2D View
 * API to update 2D View.
 */
export const update2dView = (options: Options<Update2dViewData>) => {
  return (options?.client ?? client).patch<
    Update2dViewResponse,
    Update2dViewError
  >({
    ...options,
    url: '/views2d/{viewId}',
  });
};
